<template>
    <svg
        @click="handleClick"
        @mouseover.exact="handleHover"
        @mouseleave.exact="handleHoverLeave"
        viewBox="0 0 343 386"
        preserveAspectRatio="xMidYMid meet"
        class="mx-auto map"
    >
        <path
            id="JP-23"
            class="st0"
            d="M162.6,277.6l-0.2-0.4l0.5-1.8L162,274l0.1-1.5l0.5-1.4l-0.3-0.3l-0.9,0.4l-1.1-0.4l0,0l-1-1.6
	L159,268l0,0l0.2-2.2l1.7-3l1.3,0.1l1.7-0.5l1.5-1.1v0.6l1.2,0.9v0.6l0.5,0.2l-0.1,0.5l0.3,0.3l0.3,0.1l0.3-0.2l0.9,0.4l0.5,0.7
	l0.9-0.2l0.9-0.7h0.6l0.8,0.5l-0.1,0.2h0.8v0.3l1,0.5l1.7-1.4l0.8-0.1l0,0l-0.3,0.8l0.6,0.8v0.5l1.3-0.3l0.9-0.5l1.6,0.3l0.2,0.4
	l0.8-0.3l0,0l-0.3,1l0.5,0.5l-0.6,0.6l0.1,0.5L181,269l-1.5,2v1.1l-1.3,1.9l-2.8,1.5l-0.4,1.2l0.2,2.3l0,0l-3.4,0.8l-3.4,1.2l-2,0.3
	l-0.3-0.2l0.8-1.7h0.5l0.3,0.6l2.4-1l0.9-0.5l-0.1-0.4l0.5-0.4l0.5,0.1l0.2-0.2l0.2-1.1l-0.6-0.7l-1.7-0.3l-0.5,0.5l-0.2,0.9
	l-0.8-0.6l-2.1,0.3l-1.4-1.4l0.3-1.1l-0.4-0.2l-0.4,0.6l-0.3,2.2l1,0.9l0.1,0.9l-1.7-0.6L162.6,277.6L162.6,277.6z"
        />
        <path
            id="JP-05"
            class="st1"
            d="M225.9,155.1l-0.7-2.8l-1.4-1.6l0.5-0.8l0.7,0.2l0.6,0.9l0.2-1.1l-0.3-0.4l0.4-0.6l0.2-1.4l-0.3-1.4
	l-1.1-0.4l-0.5,0.4l-0.5,0.8l-0.6,2.1l0.5,0.4l-0.1,1.3l-0.8-0.3l-0.9,0.1l-0.2,0.3l0.2,0.9l-2.1-0.1l-1-1.8l-0.2-1.3l0.1-0.7
	l1.9,1.3l0.7-0.2l1.5-1.5l0.9-1.6l0.8-2.4l0.6-3v-1.7l-1.7-1.8l0,0l0.5-0.1l1.1,0.4l0.3-0.9l0.8-0.4l0.5,0.3l0.2,0.5l1.5-0.1
	l0.8,0.3l1.4-0.4l0.9,0.2l0.5-1l1.3-0.1l0.3,0.8h0.8l1.1,1.2l1-0.8l1.3,0.8l0.8-0.6l0.8-0.1l0.7-0.6l0.7,0.1l0.2-1.1l1.2-0.5
	l-0.2,2.4l2.1-0.2l0.3,1.8L244,139l-0.5,1.2l0.1,1.3l0,0l-0.4,0.6l-0.6,0.2l-0.8,1.1l0.4,0.5l-0.1,1.6l-0.5,0.5v2.7l0.6,2.5
	l-0.6,0.2l-0.5-0.5l-0.8,0.4l0.1,1.1l1.1,0.7l-0.8,1.5l-0.4,0.1l0.7,1.2l0.1,1.1l-0.5,1.2h-0.3l-0.6,0.9l-0.4,0.1l0.2,0.7L239,161
	l-0.8,0.9v0.8l-0.5,0.1v0.6l0.4,0.1l0.6,1.3l-0.1,0.9l0.5,0.8l1.1,0.8l-0.3,1.1l0.9,0.4l-0.6,0.3l-0.5,0.8l0.3,0.2l-0.3,1l1,0.4
	l0.1,0.4l-0.8,1.4l0.1,1.1l0,0l-0.7,0.2l-1.6,1.6l-1.8,0.4l-0.3-0.2l0,0l-0.2-0.4l-1.5-0.5l-0.6-1.8l-1.1-0.1l-0.4-0.8l-1.1,0.3
	l-3.1-0.9l-0.8-0.7l-0.7-0.2l-0.2-1.2l-1,0.2l-0.4,0.5l-2.5-0.4l0,0l0.7-1.5l-0.2-0.9l0.4-0.8v-0.5l0.4-0.6l0.7-0.1l0.9-2.4l0.8-4.2
	L225.9,155.1L225.9,155.1z"
        />
        <path
            id="JP-02"
            class="st1"
            d="M247,125.4l0.9-0.8l0.6-1.1l0.6-1.8l0.2-2.4l0.6-1.1l-0.7-2.1l-0.9-1l-0.8-0.1l-0.9,1.6l-1.1,0.8
	L244,117l-0.7,0.7l-1.8,0.3l-0.9,0.9l-0.9-0.5l0.7-4.6l0.4-0.7l0.3-1.8l1.4-2l-0.2-0.8l0.3-0.6l1.7,1.6l1.3,0.1l0.9,0.5l1.6,2
	l1.5,0.8l0.9,0.1l1-0.4l2-1.7l-1.5,6.8l-0.1,5.1l0.5,5.6l1.4,4.9l1.2,1.1l0.7-0.4l0.2,0.6l1.9,1.9l0,0l-0.5,0.5l-1.4,0.6l-0.1,0.8
	l-0.9,0.7l-1.2-0.8l-0.7,0.1l-1.7,1.1l-0.7-1.1l-2,1.5l-1.5,0.4l-0.7,0.5v0.7h-0.5l-1,0.8H244l-0.5-0.7l0,0l-0.1-1.3l0.5-1.2
	l0.4-0.3L244,137l-2.1,0.2l0.2-2.4l-1.2,0.5l-0.2,1.1l-0.7-0.1l-0.7,0.6l-0.8,0.1l-0.8,0.6l-1.3-0.8l-1,0.8l-1.1-1.2h-0.8l-0.3-0.8
	l-1.3,0.1l-0.5,1l-0.9-0.2l-1.4,0.4l-0.8-0.3l-1.5,0.1l-0.2-0.5l-0.5-0.3l-0.8,0.4l-0.3,0.9l-1.1-0.4l-0.5,0.1l0,0l0.3-1.8l-0.2-1.4
	l-0.5-0.9l-1,0.1l0-0.9l1.8-1.4l1-1.8l0.6-0.4l0.6-0.3l1.2,0.7l1.4-1.1l0.8-0.1l0.4-0.6l1-3.6l0.1-3.8l-0.7-0.8l-0.7-0.1l0.2-0.4
	l0.9,0.2l0.4-0.4l0.4-2.9l1.1,0.7l0.7,1l0.6,0.4l0.7-0.2l1-1l1.1,0.4l0.6,0.7l-0.1,2.3l0.4,2.5l0.7,3.3l0.9,1.2l1.3-0.1l1.2-1.3
	l0.2-0.6l-0.2-1.2l0.3-1.4l1.5,0.5l0.7,1l-0.2,0.6h0.7l0.9,0.4l0.5,0.9L247,125.4L247,125.4z"
        />
        <path
            id="JP-12"
            class="st2"
            d="M221.6,262.8l0.1-0.2l1,0.4l0.4-0.5l-0.3-0.7l0.1-0.6l1.4-0.4l-0.1-0.5l0.3-0.1l0.2,0.4l1.5-2.2
	l0.6,0.5l0.2-0.4l-0.5-1.3l-0.8-0.8l-1.2-1.2l-0.7,0.3l-0.4-0.8l0,0l-1.1-2.3l0,0l0.3-0.3l0.2-1.3l-1.7-3.2v-1l-0.7-1.4l0,0h0.4
	l0.3,0.8l1.6,2l0.7,0.2l0.2,0.7l1,0.7l2.5,0.9l0.6,0.7l1-0.4l0.9,0.1l0.6-0.4l0.8,0.2l0.9-0.8l2-0.5l1.1,0.5h0.9l1.1,1l1.2,0.3
	l1.1,1.5l2.5,1.5l0,0l-0.1,0.6l-0.8-0.5l-1.5,0.5l-0.8-0.2l-0.8,0.2l-2.7,2.1l-1.4,1.6l-1.1,2.2l-0.3,2.3l0.5,1.2l-0.6,2.9l-0.7,0.1
	l-0.5,1l-0.3,0.1l-2.1,0.6l-0.2-0.4l-1.3,0.2l-0.8,1.1l-2,1.4l-0.5,1.2l0.1,0.6l-0.5,0.6l-1,0.4l-1.2-0.2l-0.2-0.7l-1.3-0.7v-0.3
	l0.8,0.1l1.3-0.6l-0.8-1.7l0.5-0.5l-0.4-0.4l0.3-0.7l-0.4-0.6v-0.8l0.9-0.7l0.1-0.5l-0.4-0.8l0.1-0.4l-0.8-0.5L221.6,262.8z"
        />
        <path
            id="JP-38"
            class="st3"
            d="M76.5,312.5l0.2-0.4l0.4-0.3h0.4v-0.2l-0.3-0.1l-0.4-0.2l-0.5,0.2l-0.3,0.2l-0.4-0.3l-0.2,0.4
	l-0.4-0.1l-0.1-0.2h-0.5l0.1-0.5l0.2-0.1l0.1-0.1l0.3-0.1v-0.2v-0.3h-0.3l-0.2-0.4l0.4-0.3l-0.1-0.4l-0.3-0.1l0.4-0.3h0.2l0.2-0.3
	l0.1-0.5l-0.2,0.1h-0.4l0.2-0.4l-0.5,0.1l-0.3-0.4l-0.2,0.1l-0.4,0.3l-0.9,0.6l-0.5,0.1l-0.3,0.4l-1.1,0.3l-0.6,0.5l-0.2,0.3
	l-0.3,0.3l-0.5,0.1v-0.2l0.4-0.2v-0.2h-0.5l-0.9,0.7l-0.5,0.3h-0.3l2.1-1.8l0.5-0.3l0.7-0.4l0.6,0.1l0.3-0.3l0.3-0.1h0.5l0.2-0.1
	l0.1-0.2l1.2-0.5l0.9-0.6l0.8-0.4l0.2-0.5l0.8-1l0.6-0.5l1.6-0.6l1.2-0.9l0.2-0.2l0.4-1l0.4-0.4l-0.2-0.7v-1l0.2-1l0.2-0.7l0.4,0.2
	l0.4-0.3l0.3-1.2l0.1-0.6l1.8-1.7l1.1-0.2l-0.1-0.5l0.3-0.2l-0.1-0.6l0.4-0.6l0.8,0.9l1,1.4l0.7,1.5l0.4,0.6l0.1,0.4l0.5,0.4L90,297
	l1.4-0.3l0.4-0.1l-0.1-0.5l1.2-0.2l0.2-0.3h0.4l0.4,0.3l0.7-0.3l0.7,0.1l0.5,0.1l0.7,0.3L97,296l0.7-0.5l0.2-0.3l0.1-0.4l0.2-0.1
	l0.4-0.3l0,0l0.3,0.3l0.9,0.1l0.6,0.3l0,0l-0.3,0.7l0.3,0.5v1l-0.2,0.6l-0.3,0.3l0,0h-0.4h-0.6l-0.5,0.3l-0.5-0.3h-0.2l-0.6,0.8
	l-0.2,0.3l-0.2,0.2l-2.1,0.1l-0.8-0.1h-1.5l-0.2,0.2l-0.2,0.7l-0.2,0.1l-0.5,0.2l-0.3-0.3h-0.2l-0.3,0.7l-0.4,0.8l-0.4,0.4l-0.4,0.5
	l-0.1,0.5l-0.2,0.3l-0.6,0.1l-0.2,0.6l-0.3,0.7l-0.2,0.5l0.3,0.3v0.5l-0.4,0.3l-0.6,0.9v0.3l-1.2,0.3l-0.2-0.1l-0.7,0.1l-1.3-0.2
	l-0.4,0.1l-0.3,0.3l0.4,0.3l0.1,0.9l0.1,0.2h0.2l0.2,0.7l0.4,0.1l0.3,0.4v0.6l-0.1,0.2l-0.8,0.5l-1.2,0.4l-0.3,0.5l-0.2,1.1h-0.4
	l-0.2,0.1l-0.1,0.5l-0.7,0.9l-0.2,0.1l-0.9-0.9l-0.1-0.3l-0.2,0.1L79,315l0.3,0.6v0.3l0.5,0.5H80l0.1,0.3l-0.2,0.9l0.3,0.3l0.2,0.9
	v1.3l-0.4,0.1l-0.1,0.4l0,0l-0.3-0.1l-0.9,0.4l-0.1-0.3l-0.3-0.3l-0.1-0.2l-0.5,0.2l-0.2,0.1l-0.3,0.1v0.3v0.1l-0.2,0.3h-0.4h-0.3
	H76l0.1-0.4l-0.3-0.4l0.1-0.1h0.4L77,320l-0.6-0.3l0.3-0.2l0.2,0.1H77l0.1-0.1l-0.2-0.4l0.1-0.3l-0.3-0.1h-0.1v-0.8h-0.3l-0.4,0.3
	l-0.4-0.2l-0.4,0.2l-0.1,0.1l-0.1,0.2l-0.1,0.3l-0.4-0.2l0.3-0.4v-0.4l0.1-0.4H75l0.2,0.1l0.1,0.3l0.3-0.1l0.6-0.2l0.1-0.3l-0.3-0.1
	l0.2-0.4l0.4-0.6v-0.3l-0.4-0.1h-0.1l-0.2,0.1l-0.1,0.1l-0.2-0.1l0.1-0.3l-0.4-0.2l0.1-0.3l0.3-0.4l-0.5-0.6l0.5,0.2l0.7,0.3
	l0.3,0.3h0.4l-0.1-0.4l-0.2-0.4l0.3-0.3h0.6h0.2l0.1-0.2l-0.1-0.3h-0.3l-0.4-0.3l0.4-0.2v-0.3h-0.8L76.5,312.5L76.5,312.5z"
        />
        <path
            id="JP-18"
            class="st0"
            d="M140.7,257.9l1.2,0.7l0.1,0.4h0.3l0.4-0.3l-0.6-0.8l0.2-0.1l0.5,0.4l0.4-0.6l-0.6-0.5l-0.3-0.8
	l0.6,0.1l0.4,0.7l0.8-0.4l0.1,0.4l1.2-0.4l0.2-0.4l-0.3-0.3l0.1-0.9l-0.4-0.7l1.2-1l0.4,0.6l-0.2,1.4l0.4,0.5l0.6-0.1l0.5-1.5V253
	l-0.6-1.1l-1.5-1.5l0.1-1.1l-0.8-1.2l1.1-1.3l0.4-1.5l2.1-3.1l-0.2-0.7h0.9l1.5-1.1l0,0l1.7,1.6l0.3,1.3l0.4,0.4l0.9-0.1l0.6,0.8
	l0.5,0.1l1.8-0.4l1.9,1.5l0.2,0.6l1.9-0.5l0,0l0.2,0.5l-0.5,0.4l-0.3,1.4l0.5,0.4v0.5l0.8,0.3l-0.1,0.5l0.6,0.5l0.3,1.2l-0.6,0.5
	l-0.2,0.8h-1.3l-1.1,0.5l-0.4-0.5l-0.5,0.4l-0.5-0.2l-0.5,0.4l-0.8-0.2l-0.6,0.8l-0.3-0.5h-1.1l-1.2-0.4l-0.9,0.5v1l-1,1.6l0,0
	l-1.8-0.9l-0.7,0.1l-0.3,0.7l0.8,1.8l-0.1,0.8l-1.1-0.3l-0.4,1.1l-1.3,0.1l-0.4,0.9l-0.5,0.1l-0.8-0.8l-1,2.8l-0.6,0.3l-0.4-0.4
	h-0.7l-0.1,0.5l-0.4,0.1l-0.4,0.7l0,0L140,264l-1.5-0.6l-1.7-0.2l-0.1-0.9l-1.3-1.2l0.3-1l-0.5-0.4l0.4-0.9l0,0l0.9,0.2l-0.2,1.1
	l0.2,0.3l2.6,0.4l1.8-0.4l0.3-0.9l-0.6,0.3v-0.5l-0.6-0.1l0.5-0.6L140.7,257.9L140.7,257.9z"
        />
        <path
            id="JP-40"
            class="st4"
            d="M35.5,302.8l1.2-1.4l0.1-0.6l-0.1-0.4h-0.3l-0.1-0.7h0.6l0.3-0.8l0.9-0.5L38,298h0.8l0.3,0.3l1-0.1
	l0.7-0.4l0.7-0.9l1.1,0.5L43,297l1.8,0.4l0.4,0.6l0.7-0.3l0.3-0.8l1.2-0.8l0.4,0.3l-0.7,1.4l0.2,1l-0.8,0.7l0.2,0.5l0.7-0.1l0.6,2.5
	l1.4,2.1l0.6-0.3l1.1,0.8l0,0l-0.1,0.4l0.3,0.8l-0.4,0.5l0.1,0.5l-1.9,0.1l-1-0.3l-0.9,0.2l-1.6,1.4l-0.3,1.6l-0.5,0.1l-0.5,0.7
	l0.3,0.2l0.3,1l-0.1,0.6l-0.5,0.3l-0.1,0.4l0.4,0.2v0.6l0.8,0.7l-0.5,1.4l-0.4,0.3l0,0l-1.5-0.5l-0.7-0.6h-0.8l-0.2-0.4l-0.5,1.4
	l-1.5-0.2l-1.6,1.5l0.2,1.1l-2.1-0.1l0,0l0.5-1.1L36,317l-0.7-0.8v-0.4l-0.4-0.2l0,0l0.2-1.2l0.6-1l1.9-1.4l0.5-0.9h0.5v-2.3
	l-0.4-0.2l-0.7,0.3l-1,1l-0.6-0.7l-0.8-0.2l-1.7-1.1l-0.5,0.2l-0.9-0.2l-0.7,0.3l-2.6-0.1l0,0l0.2-0.7l1.6-0.3l0.5-0.6l0.2-0.5
	l-0.4,0.3l-0.2-0.5l-0.3-0.2l-0.4,0.2l-0.2-0.4l1.2-0.4l0.3-0.4l-0.1-0.4l0.9-0.3l0.1-0.6l0.6,0.4l-0.3,0.4l0.2,0.4l0.8,0.1l0.1,0.7
	l0.5-0.1l0.2-0.3l0.7,0.1l1-0.5l0.1-0.8l0.6-0.2l-0.1-0.6L35.5,302.8L35.5,302.8z"
        />
        <path
            id="JP-07"
            class="st1"
            d="M243.8,223.5l-0.6,0.8l-2.5,1.2l-0.4,0.7v0.5l0,0l-3.4-1l-0.6-1L236,225l0.5,1.3l-1.1,0.5l-1.5,1.4
	l-0.4-0.6l-1.1-0.4L232,226l-0.8-0.3l-0.8-1h-0.5l0,0l-0.3-0.3l0.2-1.9l-0.9,0.1l-0.2-0.9l-1-1l-2.4-1l-2.4-0.3l-1.4,0.6l-0.2,0.9
	l-2.8,0.9l-0.3,0.4l-0.8,0.2l-0.2,0.4l-0.6,0.1l-0.9,0.7l-1.4,0.2l-0.7,1l-0.9,0.4l0,0l-2.3-0.7l-0.5,0.2v-0.4l0,0l0.2-0.4l-0.1-1.3
	l0.2-0.8l-0.4-1.4l0.4-1.3l-0.5-0.9L209,218l-0.6-0.8l1-1.4l0.2-1.2l0.1-1.2L209,213l0.6-0.9l2.1-0.2l0.5-0.3l0.7,0.2l0.3-1.2
	l0.4-0.2h0.5l0.4,0.3l0.4-0.2l1.3,0.2l0.5-0.2l-0.4-0.8l0.1-0.8l-0.4-1v-0.7l1.5-1l-0.1-0.2l0.7-1.3l1.6-1.7l0,0l0.8-0.2l0.6,0.7
	l0.9-0.6l0.6,0.4l0.6-0.1l0.3-0.4l1,1.7l1.2-0.5l1.5,1.1l0.7-0.6l1.3,0.3l1.3-1.6l-0.5-0.4v-2l0.3-1.7l0,0l1.4,0.7l1.1-0.6l1.1,0.7
	l0.4,1.1l2.6-0.3l0.8,0.3l0.6,0.5l-0.2,1.1l0.3,0.8l0.6,0.5l1.2,0.3l0.1-0.2l-0.5-0.4l1.6,0.1l0.1-0.2v-2.2l0.7-0.3l0.7,0.2l0,0
	l0.4,1.3l0.7,0.4v1.3l0.4,0.8l0.5,6v3.3L243.8,223.5L243.8,223.5z M240.4,226.6L240.4,226.6L240.4,226.6L240.4,226.6z"
        />
        <path
            id="JP-21"
            class="st0"
            d="M154.1,266.5l-0.7-0.7l0.3-0.2v-0.9l0.3-0.5v-1.3l0.6-0.4l-0.5-0.9l0.1-1l-0.6-0.6l0.2-0.9l-0.6-0.7
	l-0.3,0.5l-0.8-0.3l0.1-1.6l-0.7-0.1l-0.3-1.1l0,0l1-1.6v-1l0.9-0.5l1.2,0.4h1.1l0.3,0.5l0.6-0.8l0.8,0.2l0.5-0.4l0.5,0.2l0.5-0.4
	l0.4,0.5l1.1-0.5h1.4l0.2-0.8l0.6-0.5l-0.3-1.2l-0.6-0.5l0.1-0.5l-0.8-0.3v-0.5l-0.5-0.4l0.2-1.4l0.5-0.4l-0.2-0.5l0,0l0.5-1.1
	l-0.2-0.7l0.6-0.2l0.9-1.7v-0.4l-0.8-0.4l-0.3-0.6l0,0l0.6-0.1l0.3-1.1l0.8-0.6l0.3,0.6l0.4-0.4l0.9,0.5l0.3,0.8l-0.3,0.7l0.3,0.1
	l1.4-1.2l0.3-1.1l2.1-2h0.5l0.3,0.4l1.5-0.7l0.6,0.1v0.9h0.2l1.4-0.8l0.3,0.8l1.1,0.4l0.7-0.3l0.8,0.8l0.9,0.1l0,0l0.1,0.5l1,0.7
	l0.1,0.5l-0.1,0.8l-1.4,1.8l0.4,0.6v0.5l-0.8,0.7v0.8l0.5,0.5l0.7,0.3l-0.4,1.6l-1,0.8L176,249l-0.4,0.1l-0.5,1.1l-0.4,0.1l-0.3-0.3
	l-1.1,0.4l-0.4,1.1l-0.6,0.3l-0.1,0.5l0.3,0.4h1v0.5l1.2,0.4l0.8,1.8l0.8,0.7l-0.4,1.3l0.4,0.5l-0.1,1.1l0.3,0.5l1.1-0.3l0.6,0.5
	v0.9l-0.6,0.7l0.7,1l-0.9,0.3l0.3,1.3l-0.8,0.6v0.5l0,0l-0.8,0.1l-1.7,1.4l-1-0.5v-0.3h-0.8l0.1-0.2l-0.8-0.5h-0.6l-0.9,0.7
	l-0.9,0.2l-0.5-0.7l-0.9-0.4l-0.3,0.2l-0.3-0.1l-0.3-0.3l0.1-0.5l-0.5-0.2v-0.6l-1.2-0.9v-0.6l-1.5,1.1l-1.7,0.5L161,263l-1.7,3
	l-0.2,2.2l0,0L158,268l-1.7-2.5L154.1,266.5z"
        />
        <path
            id="JP-10"
            class="st5"
            d="M218.1,242.2l-0.3,0.6l-0.5,0.2l-0.5-0.5l-2.5,0.5l-1.8-1.3l-0.9,0.2l-1-0.3l-0.6,0.1l-1.7-0.9
	l-0.7-0.1l-1.2,2v0.9l-0.4,0.8l-1.5,0.1l-0.5,0.8l-1.5,0.4l-0.9,1h-1.2l-0.8,1l0,0l-0.4,0.1l-0.4-0.5l-0.6-0.2l-0.4-1.8l0.3-0.4
	l-0.3-0.7l-0.6-0.1l-0.4-0.8l0.2-0.2l0.5,0.3l0.5-0.5v-0.8l-0.4-0.4l-0.2-1.1l1-0.7l0.1-1.5l-0.3-1.1l-0.8-0.3l-0.7,0.1l-0.4,0.4
	l-0.9-0.3l-0.2,0.3l-0.4-0.1l-1.3-0.7l-0.1-1.3l0.6-1.7v-1l1-1.2l1-0.2v-1.1l1.8-0.4l1.5-0.8l0,0l0.3,0.2l0.4-0.6l1.2,0.4l0.8-0.7
	l-0.1-1h0.6l1.5-0.6l-0.3-0.4l0.3-0.9l0.9,0.1l0.1-0.3l-0.3-1.9l1.6-0.3l0.8-0.7l0.1-0.9l1.5,1.6l0.1,0.8l0.9,0.1l0.2,0.3l0,0v0.4
	l0.5-0.2l2.3,0.7l0,0l-0.6,1.5l1,0.4l-1,1.4l0.3,1.2l-0.6,0.9l-0.2,1.4l1.5,0.7l1.2-0.1l0.3,0.7l-0.8,0.6l-0.4,1.2l0.3,0.8l-1.2,1.6
	l-0.2,1l1,0.8v0.6l1.1,1l1-0.3l0.7,0.4l1.1-0.2l0.4,0.2l-0.1,0.3L218.1,242.2z"
        />
        <path
            id="JP-28"
            class="st6"
            d="M115.6,277.3l-1.1,0.9l-1.2-0.2l0,0l-0.5-1.4l-1.1-1l-0.2-0.5l0.7-1.3l-0.7-0.9l0.4-0.3l0.1-0.9
	l-0.2-0.6l0.9-0.5l0.1-0.9l0.6-0.3l0.2-1.1l0.2-0.3l0.7,0.1l0.1-0.8l-0.6-0.7l0.4-0.8l0,0l0.6,0.3l1.6-1.1l-0.3-1.2l0.1-0.4l-0.7-1
	l0.1-1.1l-0.7-0.3l-0.5-1.9l0.1-1l-0.4-0.8l-0.7-0.5l0,0l2.1-0.7l1.2-0.7l1.2,0.3l0.4,0.5l0.8-0.7l1.4,0.2l1.3-0.3l0.4,0.3l1-0.1
	l0,0v2l0.9,0.8l0.2,0.6l0.7,0.2l1.3-0.7l0.3,0.5v2.6l-0.9,0.5l-1.1-0.5l-0.4,1v1.3l1.5,0.6l1.3,1.1l0.8-0.5h1v0.8l0.9,0.8l-0.3,0.5
	l0.6,0.2l0.4-0.4h0.8l0.2,0.1v0.7l0.9-0.2l1,0.5l0.3,1.3l-0.4,0.2l-0.2,0.5l0,0h-0.4l-0.3,0.3l0.4,0.2l0.1,1l-0.2,0.4l1.4,0.8l1,0.1
	l-0.9,0.5l0.4,0.3l-0.5,2l0.7,1.2l0.1,1.4l-0.5,1.2l0,0l-0.4-0.3l0.1-0.5l-0.3-0.5l-0.9,0.3l-0.4-0.6l-1-0.1l-2,0.9l-0.1,0.7
	l-2.6,0.6l-4.3-1.7l-1.7-1.6L115.6,277.3L115.6,277.3z M125,288.3l0.2,0.8l-2.1,0.8l-1,0.8l-1.3,0.2v-0.5l-0.6-0.3l0.1-0.5l-0.4-0.2
	l-0.5-1l0.7-1l0.4,0.2l0.5-0.2l1.3-2.8l0.4-0.5h0.4l0.9-1.5l0.9-0.4l0.8-1.1l0.6-0.3l0.4,0.8l-0.6,0.7l-0.1,0.8l-1.8,2.3v1.5
	L125,288.3L125,288.3z"
        />
        <path
            id="JP-01"
            class="st7"
            d="M232.4,71.3l2.7-2.1v-0.6l-2-3.2l-1.4-1l-0.7-1.2l0.7-2.5l-0.3-0.5l1.6,0.1l0.6-0.4l0.2-0.5l0.5-0.2
	l2.8,2.7l1.9,0.9l1.1,1.3l2.5-0.5l0.2-0.4l1-0.3h0.7l-0.1,1.2l3,1.4l2.2-1.2l2-2.2l1-1.6l0.1-2.3l-1.4-2.8l0.5-1.9l-0.7-1.4
	l-0.5-2.3l1-2.1l1.5-0.9h0.8l2-1.3l0.9-1.9l0.4-2l-0.3-7.9l0.5-0.3L259,30l0.2-2.9l0.4-0.8l0.1-1.6l-0.3-3.3l-0.8-3.8l-3-7.3l0-1.3
	l0.1-1l0.9-1.3l0.8-2L257,3.3l0.2-1.3l0.8,0.8l0.1,0.5l0.4,0.2l1.8-0.3l1.3-0.9l0.5-2L263,0l0.5,0.3l0.6,1.3l0.6,0.3l0.6,1.5
	l2.3,1.7l2.2,3.1l5,5.6l3.9,7.2l2.6,2.5l2.4,3.1l5.6,4.4l1.6,0.9l0.3,0.9l1.3,1l3.7,1.9l3.2,1.3l5.9,1.7l2.8,0.5l0.4-0.3l0.3,0.8
	l-0.1,1.3l0.9,1.5l0.6,0.5l3.2,1l3.4,0.2l2.6-0.3l2.3-2l1.5-1.9l2.2-2l1.8-1.3l0.7-1.5L329,34l0.8-1.4h0.5l0.5,2.2l-1.2,2.5
	l-0.9,0.9l-0.6,2.4L326,43l-0.9,2.1l0.1,0.8l-0.8,2l0.2,1.1l1.4,2.6l1.5,2l1.5,5.2l1.5,2l-1.2-0.5l-0.2-0.5l-1.1-0.2l-0.2,0.4
	l0.2,1.3l0.9-0.7l0.5,0.4l-0.3,0.5l0.4,0.4l0.4-0.3l2.5,0.6l2.1-1.7l0.3-0.6l1.1-0.7l0.2-0.5l3.3,0.2l-0.2,0.5l-1.2,0.9l-1.7,0.3
	l-1.9,1l-0.8,2.9l-0.8-0.4l-1.2-0.1l-2.7,0.5l-1.5,0.9l-1.3-0.2l-0.6,0.6l-0.1,1.2l-1.6,2.2l-1,0.5l-1.9-0.1l-0.9-0.8v-0.5l0.3-0.3
	l-0.5-0.4l-0.7,0.1l-1.2,1.7v0.4L319,71l-2-0.1l-1.1-0.3h-3.6l-0.7-0.2l-1.6-1.3l-3.1,0.5l-2.4,1.2l-3.4,2.5l-5.3,5.3l-4.1,5.8
	l-1.5,3.3l-0.3,1.7l0.5,1.4l-0.8,3.9l-0.9,1.5v1.6l-3.7-3.7l-4.9-2l-8.1-4.4l-2.4-1.7l-1.8-2.1l-3.2-0.9l-2.2-2.1l-1.8-1.2l-1.8-0.5
	h-2.4l-3.2,1l-2.1,1.3l-2.7,2.3l-1.6,0.9l-2.1,2.4l-0.3,0.8l-1.1-0.4l-0.3-0.6l0.4-0.3l0.6,0.6l0.1-0.8l-1.4-0.4l-0.9-2.4l-0.8-0.4
	l-1.1-1.1l-0.1-0.6l-1.3-1.2l-1.2-0.1l-1.3,0.5l-1-0.6h-1.2l-1.7,1.8l-1.4,2.8l-0.7,2.6l0.3,1.9l2.3,1.2l2.7,2.3l0.8,0.1l1.4-0.5
	l2,0.3l1.2,2.2l1.6,1.2l1.1,1.9l3.1,1.4l0.5,0.9l0.8,0.6l-0.6,0.6h-1l-1.1,1.3l-1.7,0.7l-0.9-0.8l-2.8-0.9l-0.9,0.2l-0.3,0.6
	l-0.4,0.1l-0.2-0.6l0.7-0.4l-0.2-0.7l-0.6-0.4l-0.9,0.1l0.1,0.4l-0.4,1.7l-1.4,1.1l-1.3,0.1l-0.4,0.3l-0.3,3.9l-0.4,0.5h-0.9l-2,0.9
	l-0.9,1.9l-0.4,0.3l-1-0.8l-1.1,0.2l-0.9-0.7l-1.1-2.7l-0.1-0.9l0.4-1.8l1.4-3v-1.1l0.8,0.1l0.3-0.6l0.3-2.7l-0.4-2l-1.9-2.9
	l-0.7-0.4l-1.3-0.1l-0.5-1.3l-0.9-0.9l-1.1-0.4l-0.4-0.7l-0.2-1.4l0.3-1.1l0.9-1l0.3-0.9v-2.7l-0.5-2.2l0.9-1.4l1.1-0.6l2.3-0.1
	l0.6-0.9l1.4-0.7l0.9-1.9l0.8,0.6l0.6,1l0.9-0.2l0.1-1.4l0.8-0.8L232.4,71.3L232.4,71.3z M247.1,9.9L247,8.6l1.3-1.3l2.1,1.2
	l0.5,1.8l-1.8,1.5l-1.4-1.1L247.1,9.9L247.1,9.9z M215.2,91l-0.3,2.2l-0.4,0.6l-0.6,0.2v0.4l-0.6-0.5l0.1-1.7l-0.4-1.1l0.7-1.1
	l1.9-0.4l0.5-0.5v0.6L215.2,91L215.2,91z M245.6,4.2l-0.3,2.6L244.9,7L244,4l0.2-1.3l-0.6-0.3l0.1-0.7l0.6,0.9l0.7-0.2V1.8l0.3,0.3
	l0.4,0.8L245.6,4.2z"
        />
        <path
            id="JP-34"
            class="st8"
            d="M79.6,290.7l-0.8-0.7l-1.4,1.8l0.3,0.9l0.8-0.2l0.3,0.3l-0.1,0.2l-0.7,0.5l-0.3-0.3l-1.5,0.3
	l-0.2-0.6l1.1-0.6l-0.3-0.5l0.1-0.6l0.5-0.4l0.1-1l-0.7-1.7l0.1-1l-1.3-0.6l-2.3,1v0.4l-1.7,1.6l-0.2,0.5l0.3,0.1l0,0l-0.3,0.2
	l-1.3-0.3l-0.5-1.5l0.1-0.6l-0.9-0.8l-0.2-1.4l0.2-0.8l-0.3-0.7l0,0l-0.5-0.6l0.3-0.6l0.6-0.2l0.6-0.7l0.2-1.8l0.7-1l-0.6-0.3
	l0.3-0.5l1.4-0.9l0.3-1.1l0.8,0.1L73,277l0.2-0.4l1.2-0.1l0.5,0.4l0.5-0.4l-0.1-0.3l0.4-0.1l0.3,0.4l1.6,0.1l1.5-1.1l1.8-0.1v-0.9
	l-0.7-0.2l-0.4-0.5l0.9-1l1.2-0.3l2.4-3.3l0.4-0.1l1.1,0.7l0.8-0.6l1,0.8l1.4-0.4l0.6,0.2l0,0v0.3l2.1-0.3l0.4,0.5l0,0l1,1.2
	l-0.5,1.2v1.6l1.6,2l-0.3,1.1l0.4,1.9v1.4l1.2,1.6l0.1,1.7l0,0l-0.4,1.2l-0.9,0.1v0.9l-0.3,0.3l-2.4-0.5v-0.2l0.6-0.2V285l-0.6-0.2
	l0.1,0.4l-0.7,0.3l-1.6,0.7l-0.7-0.1l-0.2,1l-1.3,0.4l-1.3-0.2l-1.1,0.3l-0.4,0.6l-0.6,0.3l-0.3-0.6l-0.7,0.1l-0.3,0.9l-0.4-0.1v1
	l-1.2,0.1L79.6,290.7L79.6,290.7z"
        />
        <path
            id="JP-08"
            class="st5"
            d="M235.9,240l-0.1,2.1l0.9,3.3l2.7,5.5l1.6,2.5l0.8,0.5v0.4l0,0l-2.5-1.5l-1.1-1.5L237,251l-1.1-1H235
	l-1.1-0.5l-2,0.5l-0.9,0.8l-0.8-0.2l-0.6,0.4l-0.9-0.1l-1,0.4l-0.6-0.7l-2.5-0.9l-1-0.7l-0.2-0.7l-0.7-0.2l-1.6-2l-0.3-0.8h-0.4l0,0
	l-0.4,0.4l-0.4-0.1l-0.9-2l0.2-0.9l0,0l0.7-0.1l1.6-0.9l0.5-1.7l1.1,0.3l0.1-0.9l1-0.5l0.1-0.4l1.6-0.1l0.3-0.1v-0.5l0.7,0.2
	l0.4-0.5h0.4l0.3,0.4l0.7-0.2l0.2-1.2l0.9-1.9v-1.8l-0.6-1.9l0.3-0.4l1-0.2l0.1-0.3l-0.6-1l0.2-1.3l-0.3-1l0.1-2l0,0h0.5l0.8,1
	l0.8,0.3l0.3,1.2l1.1,0.4l0.4,0.6l1.5-1.4l1.1-0.5L236,225l0.3-0.5l0.6,1l3.4,1l0,0l0,0l0,0l0,0l0,0l0.2,0.6l-0.6,0.2l-0.5,0.9
	l-1.2,4l-0.7,1.2l-0.8,2.3l0.2,2.9L235.9,240L235.9,240z"
        />
        <path
            id="JP-17"
            class="st0"
            d="M160.1,220.9l-0.1-1.3l-0.3-0.1l-0.4,0.3l-0.3-0.3l0.6-2.3l0.4-0.4v-1.7l0.4-0.4l1.4-1.2l1.1-0.5
	l1.1,0.3l2.9-1.5l0.4-0.6l1-0.5l1.3-0.2l1.3-0.7l1,0.1l0.5,0.7l-0.2,0.5l0.4,0.8l-0.6,0.3h-1l-0.5,0.4l-0.3,1.2l0.6,1.1l-0.7,1
	l-1.8-0.1l-0.9,0.5l-0.6,1.5l-1.2,0.9l-0.6-0.5l-0.5-0.1l0.2-0.6h-0.4l-1.5,2.2l0.5,0.2l-0.2,0.6l-0.5,0.1l0.1,0.4l-0.3,0.4l0.6,0.1
	l0.6-0.6l1.1,1.1l0.8-0.6l0.2-0.7h0.6v3.5l0,0l-1.2-0.1l-0.7,0.3l-1.4,1.4l-0.6,3.5l-0.5,0.6l-0.2,1l0.2,0.5l-0.8,1.2l0.2,1.1
	l0.5,0.6l-0.8,3l0.5,1.9l-0.3,0.4l0.1,0.9l0,0l0.3,0.6l0.8,0.4v0.4l-0.9,1.7l-0.6,0.2l0.2,0.7l-0.5,1.1l0,0L159,246l-0.2-0.6
	l-1.9-1.5l-1.8,0.4l-0.5-0.1l-0.6-0.8l-0.9,0.1l-0.4-0.4l-0.3-1.3l-1.7-1.6l0,0l1.1-1.4l0.9-0.3l1.4-1.4l4.5-6l1.1-2l1.3-3.8V223
	l-1-1.5L160.1,220.9L160.1,220.9z"
        />
        <path
            id="JP-03"
            class="st1"
            d="M262.3,165.9l0.4,0.2v0.4h-0.8l0.5,0.5h0.5l0.3,0.7l-1,0.4h-0.7v0.4l0.5,0.3l0.5-0.1v0.2l-0.7,0.5
	h-0.7l-0.3,0.3l1.7,1l-0.9,0.3l-1.3-0.5l0.2,1l1,0.3l-1.2,0.2l0.7,0.6l-0.3,0.3l-1.1-0.1l-0.5,0.3l-0.4-0.5V172l-0.4-0.2l0.1,0.6
	l-0.3,0.4l0.7,0.9l-0.4,0.1l0.1,0.9L258,175l-0.7-1l0.3-0.5l-0.2-0.2l-0.9,0.1l0.2,0.8l0,0l-1.2-0.5l-1.4-0.1l-0.2,0.5l0.1,1.8
	l-0.7,0.7l0.1,0.5l-0.5,1.9l-2.5-1l-0.9,0.9l-0.2,0.7l-0.5,0.2l-1.8-1l-0.5-1.1l0.6-0.6l-0.3-0.5l-0.7-0.2l-2.2,0.3l-0.5-0.8
	l-1.4-0.5l-1.2-0.9l-1,0.1l0,0l-0.1-1.1l0.8-1.4l-0.1-0.4l-1-0.4l0.3-1l-0.3-0.2l0.5-0.8l0.6-0.3l-0.9-0.4l0.3-1.1l-1.1-0.8
	l-0.5-0.8l0.1-0.9l-0.6-1.3l-0.4-0.1V163l0.5-0.1v-0.8l0.8-0.9l0.4-1.3l-0.2-0.7l0.4-0.1l0.6-0.9h0.3l0.5-1.2l-0.1-1.1l-0.7-1.2
	l0.4-0.1l0.8-1.5l-1.1-0.7l-0.1-1.1l0.8-0.4l0.5,0.5l0.6-0.2l-0.6-2.5V146l0.5-0.5l0.1-1.6l-0.4-0.5l0.8-1.1l0.6-0.2l0.4-0.6l0,0
	l0.5,0.7h0.9l1-0.8h0.5v-0.7l0.7-0.5l1.5-0.4l2-1.5l0.7,1.1l1.7-1.1l0.7-0.1l1.2,0.8l0.9-0.7l0.1-0.8l1.4-0.6l0.5-0.5l0,0l1.4,2
	l1.5,3.5l-1,1.1l1.4,0.6l0.5,0.6l-0.1,0.3h-0.5l-0.4,0.5l0.1,1l0.3,0.5l0.5,0.2l0.5,0.9l0.7,0.1l0.4,0.7l-0.3,1.6l0.7,1.2l0.2,3
	l-0.4,1.7l0.4,0.1l-0.9,2.6h0.3l1.3-1.8v2l0.6,0.1l0.3,0.7l-0.1,0.4l-0.6,0.1l-0.9,1.2l-0.7,0.3l0.4,0.9l1.2-1.1l0.3-0.1l0.2,0.4
	l-0.4,1.3l-1.1,0.3l-0.9,0.6l-0.8,1.2l0.3,0.4l0.8-0.4l0.4,0.5l-1.7,0.3L262.3,165.9L262.3,165.9z"
        />
        <path
            id="JP-39"
            class="st3"
            d="M88.9,317.4l-0.2,1l-1-0.4l-0.6,0.4l-0.4,1.6l0.3,1.7l-1.1,0.5v1.1l1,0.6l0.3,1.5h-0.3l-1.7-1.5
	l-0.8-0.1H84l-1.2,1l-0.6-0.4l-0.3,0.2l-0.9-1.1l-1.6,0.9l-0.1-0.8l0.7-1l-0.1-0.4l1.2-1.3l-0.2-0.4l-0.8,0.1l0.1-0.4l0.4-0.1v-1.3
	l-0.5-1.3l0.2-0.9l-0.8-0.9l-0.3-0.9l0.3-0.4l1.1,1.2l0.2-0.1l0.9-1.4l0.6-0.2l0.5-1.7l1.2-0.4l0.9-0.7v-0.6l-0.7-0.5l-1.1-2.2
	l0.7-0.4l2.2,0.3l1.2-0.3l0.9-1.4l-0.3-0.8l0.6-1.8l0.8-0.4l0.1-0.5l0.8-0.9l0.6-1.5l0.5,0.3l0.5-0.2l0.6-1h4.3l1-1.2l0.7,0.3
	l0.5-0.3h1.1l0,0l0.4,0.5l1.3,0.5l1.8-0.2l0.6,0.9l0.8,0.3l0.6-0.2l0.4-0.8l0.4-0.1l0.3,0.5l0.7-0.2l0.5,1.3l0.1,2h2l0.2,0.8
	l-0.5,0.5l0.1,0.5l0.8,1.2l2.1,0.2l0,0l-1.9,3.6l-0.6,3.6l-0.7-1.2h-0.6l-0.1-0.7l-1-1l-0.4-1l-1.4-0.7l-0.5-1.1l-3.2-0.6l-0.4-0.5
	l-3.1,0.5l-0.3,0.5l-2.3,1.2v0.6l-2.2,0.4l-0.6,1.1l-0.3-0.6l-0.9,0.3l0,0.9l-0.3,0.3l0.2,0.4l-0.3,0.8l0.3-0.1L92,313l-0.3,0.2
	l0.2,0.6l-0.9,0.9l0.3,0.7l-0.2,0.1l-0.1-0.4h-0.4L88.9,317.4L88.9,317.4z"
        />
        <path
            id="JP-37"
            class="st3"
            d="M102.1,288.5l2.1-1.2l0.2-1l2.1,0.7l1.6,0.1l1.1-1.2l0.5,0.4l-0.2,1l0.2,0.4l0.4,0.1l0.1-0.4
	l0.4-0.1l1.1,0.2v0.4l-0.4,0.3l0.2,0.5l1.1,0.3l0.8,0.6l0.4-0.1l1.4,1l0,0l-0.2,1l-0.4,0.2l-1.1-0.6l-0.3,0.3l-1.6-0.3l-1.7,0.2
	l-0.7,0.6l0.1,0.4l-0.3,0.3l-1.2,0.1l-1.2,0.9h-0.5l-0.9-1l-1.4,0.3l-0.8,0.3l-0.3,0.5l-0.6-0.2l-1,0.8l-0.1,0.5l-0.6,0.2l0,0
	l-1.9-0.7l0.7-0.5l0.3-3.1l-1.5-1.2l0.1-0.3l0.3-0.1l1.6,0.8l0.6-0.2L102.1,288.5L102.1,288.5z"
        />
        <path
            id="JP-43"
            class="st4"
            d="M42,339.9l-1.3-0.6l-0.3-0.5l-0.6-0.1l-0.4-0.7l-0.5,0.8l-0.9,0.4h-0.8l-0.6,0.5l-1-0.2l-0.3-0.6
	l-0.5-0.3l0,0l0.2-1.1l1-1.1l1.3-2.6l1.7-1.7l-0.1-1h-0.4l-0.1-0.5h0.7l0.1-0.2l-0.9-0.5l2.4-2.4l-0.2-0.2l-1.1,0.5l-2.6,0.1v-0.4
	l2.7-1.8v-1.5l0.2-0.4l-0.9-1.2l-0.8-0.2l-0.1-0.8l-1.5-0.7l-0.3-1.8l-0.6-0.5l0,0l2.1,0.1l-0.2-1.1l1.6-1.5l1.5,0.2l0.5-1.4
	l0.2,0.4H42l0.7,0.6l1.5,0.5l0,0v0.3l0.9,0.2l0.6,0.8h0.6l0.4,0.6h0.4l0.5-0.6l0.2-0.9l-0.8-1.2l0.1-0.7l1-0.6l1.4,0.3l1,1.1
	l0.2,1.2l0.9,0.8l0.6,1.6l0.2,2.3l1.4,1.3l0,0l-1.3,0.2l-0.6,1v0.9l-1,0.6l-0.2,0.9h-0.6l-0.4,0.5l-0.3,1.4l-0.5,0.3l-0.7-0.2
	l-0.3,0.7l-0.4,0.2l-0.3,1.4l0.3,1.1l0.4,0.7l0.4,0.1l0.2,1.1l0.8,0.7l-0.6,1h-0.6l-0.2,0.6l1.1,1.3l0.2,0.9l-0.9,0.1l-1.1-0.4
	l-0.7,1.2l-0.4,0.1l-0.9-0.4l-1,0.7L42,339.9L42,339.9z M36,330.2l0.5-0.1l-0.2,1.3l-0.5,0.8l0.3,0.1l-0.6,0.9l-0.8,0.4l-1.2-0.5
	l-0.9,0.1l-0.1-0.4l-0.5-0.2l-0.4,0.4l0.5,0.4l0.1,0.4l-0.4,1l-1.9,1.4l-0.2,0.9l-1.1,0.7l0.1,1l-0.5,0.2l-0.7-1.1l0.3-0.9l-0.7-0.2
	l0.7-1.4l-0.4-0.6v-0.7l1.2-2.4l0.2-1.1l1.4-0.6l1.4-0.1l0.2,0.3l-0.1,0.9l0.3,1l1.6-0.8l0.6-0.7l0.9-0.3l0.6,0.4L36,330.2L36,330.2
	z M30.8,337.3l-0.1-0.7l0.6-0.6l-0.2,1l0.7,1.7l-0.5,0.3l-0.5,1.2l-1-0.8l0.1-0.8l-0.3-0.4l0.1-0.9L30.8,337.3L30.8,337.3z
	M36.5,329.3l-0.5,0.3l-0.4-0.2l-0.2-0.9l1-0.9l0.3,0.9l-0.3,0.4L36.5,329.3z"
        />
        <path
            id="JP-14"
            class="st5"
            d="M203.4,262.1l0.4-1.1l1.8-0.8l0.5-0.6l0.7-0.1l0.5-0.5l0.3-0.7v-2.6l0,0l0.6,0.1l0.5,0.6h0.6l0.6,1
	l0.9-0.2l2.2,0.7l1.4,1.9h0.3l0.2-2l-0.8-0.6l0.2-0.2l0.5,0.5l0.8-0.9l2.7,1.3l0.3,0.7l0.5,0.2v0.4l0,0l0.6-0.2l0,0l0,0l0,0l0,0l0,0
	l0,0l0,0l0.4,0.7l-1.5,0.8l-0.7-0.1l-0.4,0.4l0.4,0.5l0.4-0.1l0.4,0.3l-0.4,0.9l-0.4-0.3l-0.5,0.1l-0.1,0.4l0.5,0.3l0.3,1.3
	l-0.3,0.7l1,0.8l1.1,0.2l-0.4,1.1l-0.7,0.1l-0.6,0.5l0.1,0.6l0.3,0.1v0.4h-1.3l0.1-1.2l-0.3-1.2l-0.6-0.7l0.1-0.6l-2.5-0.6l-2.5,0.3
	l-2.1,0.7l-1.2,0.9l-0.2,2.1l-0.6,0.4l0,0l-1.5-0.2l-0.1-0.7l-0.7-0.5l-0.2-1.5l0.6-0.6l0.3-1l-0.3-1.5l-0.1-0.2L203.4,262.1
	L203.4,262.1z"
        />
        <path
            id="JP-46"
            class="st4"
            d="M32.8,355.5l1.1-1.9l0.3-2.3l-0.2-1.1l-3.1-3.2l1.1-2.7l-0.2-1.1l-0.7-1.4l0.6-1.1l-0.7-0.6l0.2-0.5
	l0.8-0.4h0.5l0.7,0.5l1.1-0.1l0.4-1l0,0l0.5,0.3l0.3,0.6l1,0.2l0.6-0.5h0.8l0.9-0.4l0.5-0.8l0.4,0.7l0.6,0.1l0.3,0.5l1.3,0.6l0,0
	l-0.5,1l0.6,0.2l1,0.9l0.4,1.4l1.1,0.4l0.7,0.9l-0.1,1.3l-0.2,0.1l0.2,0.9l0.6,0.1l0.3,0.4l1.1,0.1L47,348l0.8,0.2l0.2,1.6l0.6,1
	l0.5-0.6l0.7,0.6l1-0.1l0.5,0.3l0.3,0.9l-0.3,0.6l0.2,0.8l-0.6,0.7l-0.1,0.7l0,0l-1.2-0.4l-1,0.8l-0.7,1.1l-0.1,0.8l1.8,0.6v0.4
	l-0.6,0.7l0.2,0.2l0.8-0.3l0.1,0.3l-1.3,1.1h-1l-0.2,0.8l-0.8,1.2l-1.8,1l-1.4,0.3l-2.7,2l0.4-1.4l-0.5-0.4l1.8-1.4L43,361l-0.3-0.7
	l0.7-0.9l0.3-1.9l-0.9-2.1l-0.5-0.6l-0.7-0.3l0.1-1.9h-1.4l-0.9-0.8l0.7-0.9l1.1-0.2l0.7,0.6l-0.1,0.8l1.1,0.1l1.1-2.1l-0.5-1.1
	l-2.7-0.8l-0.8,0.7l-0.2,1.2l-0.9,1.3l0.1,0.5l-0.7,1.5h-0.2l-0.2,1l0.3,1.3l0.8,2.1l1.1,1L41,359l-0.5,1.8l-1,0.7l-0.6-0.5
	l-0.8,0.3l-0.2-0.3l0.1-0.8l-1-0.9h-2.1l-0.9-0.4l-1.9,0.4l-0.2-1.5l-0.6-0.2l0.7-0.5l-1.5-1.5l0.5-0.7l0.3,0.5l1,0.5L32.8,355.5
	L32.8,355.5z M37.5,377.5l1.4,0.6l-0.1,0.3l1.4,0.4l0.7,0.6l-0.4,1.8l-1.3,1.3l-1.2,0.3l-1.7-0.3l-0.3-0.8l-0.2,0.2v-0.7l-0.4-0.6
	l-0.3-1.1V379l0.9,0l0.7-0.9v-0.5l0.6,0.1l0.1-0.4L37.5,377.5L37.5,377.5z M46.3,374.8l-0.2-2.1l0.8-1.3h0.3l0.1-1.3l1.1-1.3L49,370
	l-0.2,0.6l0.2,1.6l-0.5,0.7l0.1,1.1l-0.5,0.6v0.5l-0.7,0.4l-0.7,1.5l0.1,0.3l-0.2,0.3l0.4,0.5l-0.2,0.5l0.3,0.4l-0.3,0.1v0.5H46
	l-1,0.7l-0.3-0.6l0.2-0.9l-0.3-1.4h0.5L46.3,374.8L46.3,374.8z M22.2,350.5l-0.8,0.5l-0.4-0.3l-0.1-0.6l0.4-0.2l0.4-1.1l1.3-0.5
	l0.4-1.2l0.4,0.2l-0.1,0.5l-0.6,1.1l-0.6,0.2l0.1,0.4l-0.4,0.4l0.3,0.3L22.2,350.5L22.2,350.5z M24.4,346l-0.3-0.6l0.3-0.5l0.5,0.1
	l0.4,0.5l0.8-0.2l0.1,0.4v0.6l-0.9,0.3l-0.5-0.3l0.1-0.3l-0.4-0.3L24.4,346z M32.2,377.3l0.7,0.5v0.3l-0.4-0.1l-0.7,0.4l-0.4-0.5
	l0.1-0.5l-0.5,0.1l-0.5-0.8L32.2,377.3L32.2,377.3z"
        />
        <path
            id="JP-26"
            class="st6"
            d="M133.6,270.6l0.2-0.5l0.4-0.2l-0.3-1.3l-1-0.5l-0.9,0.2v-0.7l-0.2-0.1H131l-0.4,0.4l-0.6-0.2
	l0.3-0.5l-0.9-0.8v-0.8h-1l-0.8,0.5l-1.3-1.1l-1.5-0.6v-1.3l0.4-1l1.1,0.5l0.9-0.5v-2.6l-0.3-0.5l-1.3,0.7l-0.7-0.2l-0.2-0.6
	l-0.9-0.8v-2l0,0l0.3,0.3h1l0.6-0.3l0.4-0.8l0.8,0.1l1.9-1.4l1.9-0.6l1.1,0.7l0.7,1.2l-1.1,1l-0.2,0.7l-1.1,1.3l0.1,0.6h0.3l0.6-1
	l0.6,0.3l0.1,0.2l-0.6,0.5l1.4,0.6l0.3-0.3l0.1,1.4l0.5-0.5l0.8,0.2l0.1-0.5l-1.3-0.8l0.9-0.7l0.9-0.1l0.1-0.6h0.4v0.6l0.4,0.3l0,0
	l-0.4,0.9l0.5,0.4l-0.3,1l1.3,1.2l0.1,0.9l1.7,0.2l1.5,0.6l1.4-0.3l0,0l1.2,1.8h0.4l-0.4,1.4l0.4,2.1l-0.3,1.7l-0.3,0.3l0.3,1.2
	l0.9,1.5l-0.2,1.1l0.7,0.5l0.7-0.4l0.1,0.9h0.3l0.3,0.4l0.4-0.1l0.6,0.6l-0.3,0.3l0.1,0.4l0,0l0.4,1.2l0,0l-0.3,0.8L146,279
	l-0.5-0.7h-1l0.1-0.4l-0.7,1.1l-0.7,0.1l-1.9-0.5l-0.5-1.2l0,0l0.3-0.6l-1-1.1l-0.3-1.1l-1.2-1.1v-0.6h-0.8l-0.3,0.7l0.4,0.4
	l-0.8,0.3l-0.7-0.7l-0.3,0.1l-0.1-1.2l-2.2-0.6L133.6,270.6z"
        />
        <path
            id="JP-24"
            class="st6"
            d="M159.6,288.6l-0.2,0.1l0.7-1.2l-0.6-0.3l-0.7,1.4l-1.1,0.7h-0.4l-0.3-0.8l-0.3,0.1l-0.2,0.8
	l-0.1-0.7h-0.7l0.3,0.9l-0.2,0.2l-2.9,0.7l-0.4-0.1l-0.6,0.5l-0.6,1l0.4,0.6l0.4-0.1l-0.4,0.7l-0.6,0.1l-0.4-0.5l-0.4,0.1l0.2,0.3
	l-0.7,0.2l0.2,0.3l0.7-0.1v0.7l0.7,0.4l-0.2,1.2l-0.7,0.1l-0.8,1.1l-0.9,0.2l-0.4,0.7h-0.6l-1.1,1.9l-0.7,2l0,0l-1.3-0.3l-1.7-1.9
	l0.1-1.9l0,0l1.1-1.7l1.2-0.4l0.8-1.1l1.6,0.3l-0.1-1.3l0.2-0.3l0.1-1.8l-0.4-0.7l0.7-1.4l-0.7-1.1l0.7-0.4l-1.2-1.9l0.5-1l2.2-0.3
	l0.4-0.9l-0.3-1l-0.6,0.3l-0.5-1l-0.8,0.3l-1-0.5l-0.3-0.4l0.4-1l-0.1-0.6l0.4-0.5l-0.8-1.6l0,0l-0.4-1.2l0,0l1.3-0.5l-0.1-0.5
	l0.8-0.6l-0.1-0.3h-0.6l-0.1-0.3l0.5-0.4l0.3,0.4h1l1.3,0.7l2.3-1.1l0.2-0.9l0.8-1.1v-1.4l0.7-2.5l-0.7-0.7l-0.1-0.9l0,0l0,0l0,0
	l2.2-1l1.7,2.5l1.1,0.1l0,0l0.3,1.2l1,1.6l0,0l-0.8,0.2l-0.9,0.7l-0.4,1l0.3,1.1l-1.9,3l-0.6,1.6l0.1,0.7l0.7,0.3l-0.4,1.3l2.1,0.6
	l0.3,0.7l1.3,0.5l1.1,0.8h1.2l0.2,0.6l0.6,0.1l-0.2,0.3l0.2,0.3l0.7-0.1l0.3,0.3l0.1,0.7l-1.1,0.7l0.1,0.3l0.6,0.1l-0.6,0.7l0.3,0.5
	l-0.5,1.3l-1,0.3l-1.4-0.5l1.1-0.2l0.5,0.3l0.1-0.6l-0.5-0.1l-0.3,0.2l-1.5-0.3L159.6,288.6L159.6,288.6z"
        />
        <path
            id="JP-04"
            class="st1"
            d="M245.7,189.6l-0.4,0.7l0.3,0.3l0.3-0.1l0.2,0.6l-1.3,0.8l-1.7,3.6l-0.4,3.7l0.3,1.9l0,0l-0.7-0.2
	l-0.7,0.3v2.2l-0.1,0.2l-1.6-0.1l0.5,0.4l-0.1,0.2l-1.2-0.3l-0.6-0.5l-0.3-0.8l0.2-1.1l-0.6-0.5l-0.8-0.3l-2.6,0.3l-0.4-1.1
	l-1.1-0.7l-1.1,0.6l-1.4-0.7l0,0l-0.1-2h1.7l1-0.6l0.2-1l1.1-1.6l-0.2-1.2l0.2-1l1-1.3l-0.2-0.6l1.1-1.1l0.6-1.6l-0.2-0.7l-0.6-0.4
	l-0.3-0.9l0.4-0.6v-0.5l-0.6-1.4l0.1-0.2l0.7,0.4l0.4-0.1l0.4-1.1l-0.2-1l0.7-1.1l-0.8-0.4l-0.2-1.1l-1.1-1l0.2-0.4l0,0l0.3,0.2
	l1.8-0.4l1.6-1.6l0.7-0.2l0,0l1-0.1l1.2,0.9l1.4,0.5l0.5,0.8l2.2-0.3l0.7,0.2l0.3,0.5l-0.6,0.6l0.5,1.1l1.8,1l0.5-0.2l0.2-0.7
	l0.9-0.9l2.5,1l0.5-1.9l-0.1-0.5l0.7-0.7l-0.1-1.8l0.2-0.5l1.4,0.1l1.2,0.5l0,0l0.9,2.9l-0.4-0.1l-0.5-0.8l-0.7,0.2l-0.1,1.7
	l-1.4,0.8l-0.1,0.6l1,0.7v1.2l-0.7-0.6l-1,0.9l-0.6,0.2v0.7l1.7,0.2l-0.1,0.7l-0.7,0.6l-0.5,0.1v0.5l0.5,0.2l0.2,0.5l0.5-0.2
	l0.6,0.4l-0.3,0.9l-0.5-0.6l-0.4,0.1v1.6h-0.9l0.4,0.3l0.1,0.9l1.3-0.2v0.3l-0.7,0.1l0.7,1.8l-0.3,1l-1.5-1.1l0.3-0.5l-0.9-0.3
	l0.3-0.4l0.6-0.2l-0.5-0.6l-1.1,0.4l-0.2-0.7l-0.3-0.1l-1-0.1l-1.6,0.4l-1.3,0.8l0.1,0.9l-0.5,0.2l-0.1-1.4l-0.9-0.1l-0.5,0.3
	L245.7,189.6L245.7,189.6z"
        />
        <path
            id="JP-45"
            class="st4"
            d="M57.3,341.2l-1,3.4l-0.1,1.5l0.8,1.2l-0.6,1.6l0.1,2l-0.8,0.5l-0.9,2.1l0.2,0.8l-0.6,0.3l0.2,1
	l-0.8,0.7l0.3,0.7h-0.5l-0.5-0.5l-0.9,0.1l-0.7-1.5l-1.1-0.3l0,0l0.1-0.7l0.6-0.7l-0.2-0.8l0.3-0.6l-0.3-0.9l-0.5-0.3l-1,0.1
	l-0.7-0.6l-0.5,0.6l-0.6-1l-0.2-1.6L47,348l0.2-0.6l-1.1-0.1l-0.3-0.4l-0.6-0.1l-0.2-0.9l0.2-0.1l0.1-1.3l-0.7-0.9l-1.1-0.4L43,342
	l-0.8-0.8l-0.6-0.2l0.5-1l0,0h2.6l1-0.7l0.9,0.4l0.4-0.1l0.7-1.2l1.1,0.4l0.9-0.1l-0.2-0.9l-1.1-1.3l0.2-0.6h0.6l0.6-1l-0.8-0.7
	l-0.2-1.1l-0.4-0.1l-0.4-0.7l-0.3-1.1l0.3-1.4l0.4-0.2l0.3-0.7l0.7,0.2l0.5-0.3l0.3-1.4l0.4-0.5h0.6l0.2-0.9l1-0.6v-0.9l0.6-1
	l1.3-0.2l0,0l0.5,0.6h0.4l2-0.7l0.8,0.9l-0.2,0.5l0.2,0.3l0.9,0.3l0.5-0.4h2.2l0.5-0.6l0.1-0.7l0.8-0.1l1.6,0.6l-0.3,1.6h0.6l0,0
	l-0.2,0.5l-1.6,1l-0.6,1.7l-1.1,0.5l-0.4,0.9l0.2,0.6l0.7,0.5l-0.7,0.5l-0.9,0.2l0.2,0.5l0.6,0.4l-0.9,0.4l-1.2,2.8L57.3,341.2
	L57.3,341.2z"
        />
        <path
            id="JP-15"
            class="st0"
            d="M189.5,219l1.9-1.2l2.6-2.6l2.3-1.3l2.3-3.9l0.8-0.6l0.7-1.2l1.4-4.6l0.9-1.1l4.1-2.9l2.4-0.6
	l1.7-1.1l1.8-1.9l1.2-2l0.4-1.6l0.1-3.9l1.9-3.8l0,0l1.8,1l1.5,0.3l0.2,0.3l-0.4,2l0.8,1.1l1.8,0.5l1.1,1.2l-0.8,1.6l-1.4,0.9
	l-1.6-0.2l-0.5,0.8l0.2,1.3l-0.3,0.8l0.4,0.8l-0.7,0.5l-0.6,3.2l0.7,1.2l0.7,0.3l0.5-0.1l0.5,0.8l0,0l-1.6,1.7l-0.7,1.3l0.1,0.2
	l-1.5,1v0.7l0.4,1l-0.1,0.8l0.4,0.8l-0.5,0.2l-1.3-0.2l-0.4,0.2l-0.4-0.3h-0.5l-0.4,0.2l-0.3,1.2l-0.7-0.2l-0.5,0.3l-2.1,0.2
	l-0.6,0.9l0.7,0.6l-0.1,1.2l-0.2,1.2l-1,1.4l0.6,0.8l0.7,0.2l0.5,0.9l-0.4,1.3l0.4,1.4l-0.2,0.8l0.1,1.3l-0.2,0.4l0,0l-0.2-0.3
	l-0.9-0.1l-0.1-0.8l-1.5-1.6l-0.1,1l-0.8,0.7l-1.6,0.3l0.3,1.9l-0.1,0.3l-0.8-0.1l-0.3,0.9l0.3,0.4l-1.5,0.6h-0.6l0.1,1l-0.8,0.7
	l-1.2-0.4l-0.4,0.6l-0.3-0.2l0,0L199,229l-0.4-0.3l0.5-0.9l-0.2-0.5l0.1-0.7l-1-0.4l-1-1.1v-1.6l-0.4-0.9l-0.8-0.2l-2.6,0.8
	l-0.7,1.6l-1.2,0.5L191,227h-0.3l-0.3-0.6l-0.9-0.1l-1,0.7h-1.2l-0.9,1.1l-1-0.7l0.5-1.3l-0.4-0.6l-1.9-0.4l-1,0.1l0.1,1.3l-0.8,1.3
	l-1.4,1.1l0,0l-0.6-1.7v-0.8l-0.4-0.6v-1.2l-0.8-0.3l-0.7-0.8l0,0l5.4-2l1.8-1.3l0.9-0.3l0.9-1.1l1.1,0.3L189.5,219L189.5,219z
	M194.5,194.2l-0.6,1.3l0.2,1.1l0.7,0.3l1.6-0.6l0.2,0.3l-1.4,3.9l-2.8,2.2l-1.1,0.1l-1,0.6l-0.7-0.1l-0.2-0.5l1.3-0.6l0.3-0.8
	l-0.1-0.9l1.1-1l0.2-0.9l-0.3,0.4l-0.5-0.6l-0.6-0.1l-0.6,1.1l-0.4-0.2v-0.9l-0.2-0.1l0.4-0.4v-1.4l1-1.3l0.7-1.6l0.8-0.4l0.7-1
	l0.7-0.2l0.5-1.5l1.1-0.3l-0.4,3.2L194.5,194.2z"
        />
        <path
            id="JP-20"
            class="st0"
            d="M176.7,264.8v-0.5l0.8-0.6l-0.3-1.3l0.9-0.3l-0.7-1l0.6-0.7v-0.9l-0.6-0.5l-1.1,0.3l-0.3-0.5
	l0.1-1.1l-0.4-0.5l0.4-1.3l-0.8-0.7l-0.8-1.8l-1.2-0.4v-0.5h-1l-0.3-0.4l0.1-0.5l0.6-0.3l0.4-1.1l1.1-0.4l0.3,0.3l0.4-0.1l0.5-1.1
	l0.4-0.1l0.4-0.9l1-0.8l0.4-1.6l-0.7-0.3l-0.5-0.5v-0.8l0.8-0.7v-0.5l-0.4-0.6l1.4-1.8l0.1-0.8l-0.1-0.5l-1-0.7l-0.1-0.5l0,0
	l0.9-0.9l0.4-0.8v-0.8l0.4-0.5l0.6-0.2l-0.1-0.5h-0.2l0.1-0.8l1.2-0.7l0.2-4.2l0,0l1.4-1.1l0.8-1.3l-0.1-1.3l1-0.1l1.9,0.4l0.4,0.6
	l-0.5,1.3l1,0.7l0.9-1.1h1.2l1-0.6l0.9,0.1l0.3,0.6h0.2l0.3-1.6l1.2-0.5l0.7-1.6l2.6-0.8l0.8,0.2l0.4,0.9v1.6l1,1.1l1,0.4l-0.1,0.7
	l0.2,0.4l-0.5,0.9l0.4,0.2l0.1,0.5l0,0l-1.5,0.8l-1.8,0.4v1.1l-1,0.2l-1,1.2v1l-0.6,1.7l0.1,1.3l1.3,0.7l0.4,0.1l0.2-0.3l0.9,0.3
	l0.4-0.4l0.7-0.1l0.8,0.3l0.3,1.1l-0.1,1.5l-1,0.7l0.2,1.1l0.4,0.4v0.8l-0.5,0.5l-0.5-0.3l-0.2,0.2l0.4,0.8l0.6,0.1l0.3,0.7
	l-0.3,0.4l0.4,1.8l0.6,0.2l0.4,0.5l0.4-0.1l0,0l-0.1,0.5l0.5,1.1l-0.2,0.5l0,0h-0.4l-0.7,0.9h-1l-0.5-1.1h-1.8L195,250l-0.5,0.1
	l-0.5-0.5v-0.7l-1.4-0.6l-1.8,2.7l-0.7-0.6l-0.2,0.1l-1,2l0.9,0.9l-1,1.1l0.7,1.8l0,0l-0.6,1.6l-0.4-0.1l-0.6,0.6l0.3,0.3l-0.4,0.6
	l0.4,1.3l-0.7,0.3v0.7l0.5,0.7l-0.1,0.7l-1.6,0.6l-1.2,1l-1.3,0.6l-0.2,0.4h-0.5l-0.5,0.9l-1.1,0.1l0,0l-0.8,0.3l-0.2-0.4l-1.5-0.3
	l-0.9,0.6l-1.3,0.3v-0.5l-0.6-0.8L176.7,264.8z"
        />
        <path
            id="JP-29"
            class="st6"
            d="M146.8,277.9l0.8,1.6l-0.4,0.5l0.1,0.6l-0.4,1l0.3,0.4l1,0.5l0.8-0.3l0.5,1l0.6-0.3l0.3,1l-0.4,1
	l-2.2,0.3l-0.5,1l1.1,1.9l-0.7,0.4l0.7,1.2l-0.7,1.4l0.4,0.7l-0.1,1.8l-0.2,0.3l0.1,1.3l-1.6-0.3l-0.8,1.1l-1.2,0.4l-1.1,1.7l0,0
	l-2,0.3l-0.7-0.4h-0.7l-1.1,0.7l-0.2-0.6l-0.4-0.1l0.7-1.8l-0.3-0.5l-0.6-0.2l0.1-0.5l-1.1-1l0.1-0.5l1.5-1.5l0.4-0.6v-0.7l0.5-0.3
	l0.8,0.4l0.4-0.6l-0.2-0.6l-0.9-0.5l-0.2-1.7l-0.4-0.7l0,0l0.6-0.4l0.2-1.1l-0.1-1.2l-0.5-1.3l0.6-0.9l-0.2-0.5l-0.4-0.1l0.5-2.4
	l0.5-0.4l0.2-1.4l0.4,0.1l0,0l0.5,1.2l1.9,0.5l0.7-0.1l0.7-1.1l-0.1,0.4h1l0.5,0.7l0.6,0.1L146.8,277.9z"
        />
        <path
            id="JP-42"
            class="st4"
            d="M32.8,322l0.9-0.1l0.5,0.4l0.9,1.7v1.1l-0.6,0.8l0.2,0.3l-0.2,0.5l-1.6,0.6l-0.7,0.9l-1.3,0.5V328
	l-0.8-0.5l0.1-0.9l1.4-1.1l0.1-0.6l-0.5-0.3l0.2-0.4l-0.3-0.3h-1.9l-1.1,0.7l-1.5-0.1l-0.2,1l-0.9,1.5l-1,0.6l-0.8,1.1l-1.3,0.5
	l0.2-0.5l0.6-0.2l1-3l-1.3-1.5l0.2-0.5l-0.6-0.1l-0.2,0.4l-0.9-0.9l-0.6-1.8l-0.6-0.8l-0.1-0.6l0.5-0.7l0.2-1.6l1-0.3l0.6,0.7
	l-0.2,1.2l0.4,0.1l0.3-0.4l1,0.6v1.6h-0.4l0.2,0.7l-0.3,0.7l0.6,0.1l0.6,0.8l1-1.1l1.6,1l0.6-0.3l-1.5-1.8l0.4-1.5l-0.4-0.9
	l-1.4-0.9l-1.6,0.1l-0.8-0.4l-0.3-2l-0.4,0.1L22,316l-0.9,0.6l-0.2-0.7l0.6-0.1l-0.2-0.7l-0.8-0.1l-0.3-0.7l-0.7-0.5h-0.6L19,313
	l0.6-0.4l-0.3-1.4l0.4-1.1l0.6,0.5l0.9-0.9l0.3,0.3l-0.3,0.5l0.2,0.3l0.8,0.1l0.7-0.5l0.3,0.3l0.3-0.5l0.2,0.8l0,0l-0.6,1l1.1,1.4
	v1.3l1.4,0.6l1-0.1l0.4,0.9l-0.1,0.4l-0.5,0.1l-0.1,0.4l1.2,0.8l1.6,1.6l2.8,0.7l0,0l-0.1,0.6L31,321l-0.8,0.9l0.9,0.7L32.8,322
	L32.8,322z M14.4,287.7l0.3-1.1l-0.6,0.7h-1.3l-0.5-0.3l0.5-0.1l0.3-0.4l0.1-2L14,283l0.4-0.2v-0.4l-0.8-0.1v-0.4l0.4-0.4l0.3-1.4
	l1.4-0.1l0.4-1l0.7-0.4l0.7,0.3l0.3,0.6l-0.6,1.5l0.1,1.2l-0.8,1.2l-1.3,1.2l0.6,1l-0.3,1.1l0.5,0.1l0.1,0.3l-0.9,0.7v0.4l0.4,0.2
	L15,289l-0.6-0.1l-0.9,3.5l-1.4,1.1l-0.2-0.5h-0.7l0.8-5.4l0.5,0.3l-0.1,0.6l0.8-0.3v-0.4L14.4,287.7L14.4,287.7z M4.8,325l0.1,1.2
	l0.9,0.8l-0.1,0.3l-1.4,0.1L4.1,327l-0.7,0.3l-0.2,0.6l0.5,0.3l0.1,0.4L3.4,329L3,328.9l-0.3-0.7l-1.6,0.4L0,328l0.3-0.8l0.2,0.3
	l1-0.4L1,326.4l-0.2-1.9l0.3-0.5h0.5l0.5,0.7l2-1.1v0.5L4.8,325L4.8,325z M10,317.8l-0.3,1.5h0.7l0.9-0.6l0.3,0.1v0.6L9.8,321
	l0.1,1.3l-0.7-0.1l-0.1,1.1l-0.3-0.2l0.3-1.5l-0.5-1.3l-0.3,0.3l-0.6-0.3l0.4-0.8h0.7l-0.1-1.2l1.2-1.2l-0.2-1l0.4-1l0.2,1.3
	L10,317.8L10,317.8z M18.3,310.1l0.3,0.1l0.1-0.3h-0.6l0.2-0.4l0.6-0.1L19,310l-0.2,0.3l0.3,0.3l-0.5,0.2v0.4l-0.4,0.1l0.2,0.4
	l-1.3,2.3l-1.8,1l-0.4-0.3l0.1-0.5l0.4,0.4h0.4l-0.3-0.9l0.9-0.5l-0.4-0.6l0.8-1.3l1.3-1.3L18.3,310.1L18.3,310.1z M5.1,322.6
	l0.8,0.5l-0.4,1.4L4.8,324l-0.1-1.3L5.1,322.6z M8.1,322.2L7.6,322l-0.4-0.7l0.7,0.1l-0.4-0.5l0.2-0.3l0.9,0.8l-0.1,1.2L8.1,322.2
	L8.1,322.2z M10.7,312v0.4l0.3,0.1l-0.6,0.3v0.2l-1.1-0.2l-0.1-0.3l0.4-0.4h0.6l0.1-0.3L10.7,312L10.7,312z M6.7,323.6l-0.2-0.4
	l-0.3-0.1v-0.4l-0.8-0.5l0.3-0.4l0.6,0.2l0.3,0.7l0.4-0.8l0.2,0.1l0.1,0.4L6.8,323l0.2,0.3L6.7,323.6L6.7,323.6z M15.9,310.2
	l0.6-1.7v2.1l-0.7-0.1L15.9,310.2z M19.3,307.7l-0.4,0.3l-1.1-0.1L19,307l0.5,0.4L19.3,307.7L19.3,307.7z M9.1,314.6l-0.2,0.1
	l-0.4-0.3l0.3-0.5l0.4,0.3l0.6-0.2l-0.2,0.7C9.7,314.6,9.1,314.6,9.1,314.6z"
        />
        <path
            id="JP-47"
            class="st9"
            d="M298.8,337.3l0.8-0.8l2.1-0.9l0.4-0.8l-0.7-0.6l-1-0.1l-0.3-0.8l0.3-0.4l-0.4-0.5l0.1-0.6l0.5,0.3
	l1.1-0.2l0.8,0.3l0.2,0.2l-0.3,0.7l0.3,0.5l0.9-0.1l0.9-0.6l0.3-0.9l0.8-0.4v-0.3l1.4-1.4l0.4-1l-0.1-0.6l0.3-0.1l0.9,0.7l0.4,2
	l-1.8,2.6h-1.8l0.1,0.7l-0.5-0.1l0.5,0.8l-1.1,0.7l-1.1-0.4l0.3,0.7l-1.7,1.2l-0.3,0.7l-1.6-0.5l-0.8,0.6l0.2,0.6l0.7,0.5l-0.1,0.5
	l1,1.1l-0.1,0.4l-1-0.9l-0.7,0.1l-1.3,2.8l0.2,0.3l0.7-0.1l0.3,0.6l-1.6,1l-0.4,0.6l-1,0.3l-0.4-0.2l-0.4-2.5l1.4-1.6l1-0.5v-0.3
	l-0.9-2.1v-0.6l0.2-0.1l0.2,0.4L298.8,337.3L298.8,337.3z M333.9,295.1l-1.1,1.4l-1.1,0.4l-0.5-0.2l-0.3,1.1l0.4,0.8l-1.1,0.7
	L330,300l-0.4-0.3l-0.3,0.3l0.2,1l-1.6-0.9v-0.5l-0.5-0.9l-1.9-0.3l-0.9-0.7l1.8-0.5l0.2-0.2l-0.4-0.5l1-0.6h0.8l0.7-0.9l0.5,0.3
	l0.5-0.7l1,0.1l0.3-0.7l0.3,0.3h0.6l0.2-0.9l0.5-0.5l0.5,0.1l1-0.5l0.2,1l-0.2,0.3l0.4,0.2l0.7-1l-0.6-0.9l0.9-0.6l0.1,0.9l0.5,0.3
	l-0.1,1l-1,0.7l-1-0.1L333.9,295.1L333.9,295.1z M222.4,382.9l-0.2,0.9l-0.5,0.2v0.7h-0.4l-0.1,0.5l-0.9-0.4l-1.6-0.2l-0.6-0.4
	l-0.1,0.5l-0.8-0.1l-0.4-0.5l0.8-0.9l0.5,0.2l0.3,0.5l0.2-1.2l-0.2-0.4l0.7-1l0.7,0.6l1.2,0.2L222.4,382.9L222.4,382.9z
	M321.6,306.5v0.9l1.4,1.2l-1,2l-1,0.2l-1.1-1.4l0.5-0.9l-0.5-1.6l0.4-1.3h1.4C321.6,305.8,321.6,306.5,321.6,306.5z M226.9,381
	l1.1-0.1l-0.1-0.4l0.7-1l0.4,0.3l0.3-0.7l-0.3-0.4l0.5-0.6l0.1-0.5l0.6,0.1l-0.1,0.8l-0.6,0.5l0.1,0.3l-0.5,0.5v0.4l-0.6,0.5
	l0.2,1.1l-0.4,1.4l-1.7,0.4l-0.2-0.5l-0.6-0.3l0.5-0.5l0.1-0.6l-0.9-0.4l-0.3,0.4l-0.3-0.3l0.1-0.5l0.8,0.2v-0.8
	C225.9,380.2,226.9,381,226.9,381z M248.3,374.3l0.2-0.3l0.1,0.4h0.3l-0.6-1l0.4-0.3l0.1-0.6l-0.6-1.4l0.2-0.2l1.4,2v0.5l1.9,0.8
	l0.4,0.7l-2.9,0.4l-0.9-0.5L248.3,374.3L248.3,374.3z M314.8,317.4l-0.6,0.5l-0.8,0.2l-0.6-0.5l-0.1-0.8l0.2-0.4l1.2,0.2l1.9-1h0.4
	L314.8,317.4L314.8,317.4z M326.5,299.8l0.4,0.2l0.3-0.5l0.6,1.1l1.1,0.2l0.2,0.3l-0.3,0.6l-0.4,0.2l-0.5-0.5l-0.2,0.6l-0.7-0.8
	l-0.7,0.5l0.1-1.4l-0.6-0.4l-0.3-0.7l0.7-0.3l0.2,0.2l-0.3,0.2L326.5,299.8L326.5,299.8z M278.2,340.3l-0.9-0.5l-0.3-0.5l1.5-0.4
	l0.8,0.9l-0.4,0.5l0.1,0.7l-0.7-0.3C278.4,340.7,278.2,340.3,278.2,340.3z M342.5,295.2l-1.2,1.9l-0.6,0.2l-0.5-0.4v-0.7l0.6-0.1
	l1.2-1.1L342.5,295.2L342.5,295.2z M246,373v-0.7l0.3,0.4l0.2-0.7l0.9,0.4l0.2,0.7l-1.2,0.3L246,373z M301.5,324.5l0.9-1l0.5-0.1
	l-0.6,1.1l-1.5,1.2L301.5,324.5L301.5,324.5z M298.8,331.3l0.2,0.5h-1.3l-0.3-0.2l0.2-0.4C297.7,331.2,298.8,331.3,298.8,331.3z
	M289.8,342.4l0.3,0.2v0.5l-0.3,0.2l0.1,0.5l-0.5,0.4l-0.1-1L289.8,342.4L289.8,342.4z M301.2,326.4l0.4,0.5l-0.1,0.5l-0.3,0.1
	l-0.6-0.6L301.2,326.4z M223.6,385.1l0.6,0.3l-0.3,0.5l-0.5-0.4L223.6,385.1L223.6,385.1z M288.9,341.9l0.4,0.2l-0.5,0.5l-0.5-0.1
	L288.9,341.9z"
        />
        <path
            id="JP-27"
            class="st6"
            d="M134.5,283l0.4-0.8l-0.6-0.1v-0.8l0.3-0.5l0.7-0.4l-0.5-0.2l0,0l0.5-1.2l-0.1-1.4l-0.7-1.2l0.5-2
	l-0.4-0.3l0.9-0.5l-1-0.1l-1.4-0.8l0.2-0.4l-0.1-1l-0.4-0.2l0.3-0.3h0.4l0,0l0.2,0.7l2.2,0.6l0.1,1.2l0.3-0.1l0.7,0.7l0.8-0.3
	l-0.4-0.4l0.3-0.7h0.8v0.6l1.2,1.1l0.3,1.1l1,1.2l-0.3,0.6l0,0l-0.4-0.1l-0.1,1.4l-0.5,0.4l-0.5,2.4l0.4,0.1l0.2,0.5l-0.6,0.9
	l0.5,1.3l0.1,1.2l-0.2,1.1l-0.6,0.4l0,0l-1.3,0.2l-1.2,0.8l-1.6-0.1l-2.1,0.7l-1.6,0.1l-1.2,0.8l-1,0.2h-0.4l-0.1-0.9l-0.3-0.1l0,0
	l2.6-0.9l1.8-1.7l1-1.5L134.5,283L134.5,283z"
        />
        <path
            id="JP-33"
            class="st8"
            d="M107.1,281.9l-1.4,1.1l-0.5,1.7l-2-0.5l-0.5,0.3l-1.8-0.3l-0.6-0.8l-1.6,0.3l-0.3,0.3l0.2,0.2
	l-2.2,0.8l-0.7-0.8l0,0l-0.1-1.7l-1.2-1.6v-1.4l-0.4-1.9l0.3-1.1l-1.6-2v-1.6l0.5-1.2l-1-1.2l0,0l0.4-0.3l0.2-0.8l0.4,0.2L95,269
	l-0.3-1.2l0.3-0.4l0.8,0.3l1.2-0.5l0.2-0.5l-0.2-0.5l1-0.3l0.8-2.4l1.7,0.6h1.3l1.1,0.7l0.5,0.9l0.7-0.5l0.2-0.5l1.2-0.5v-0.5
	l1.5-0.4l-0.1,0.9l0.2,0.2l0.8,0.2l0.9-0.2l0.7,0.6l0.2,0.4l-0.1,0.6l0.5,0.3l-0.2,0.7l0.5,0.6l1.5-0.9l0.5,0.3l0.7-0.1l1.4-1.2
	l0.3,0.2l0,0l-0.4,0.8l0.6,0.7l-0.1,0.8l-0.7-0.1l-0.2,0.3l-0.2,1.1l-0.6,0.3l-0.1,0.9l-0.9,0.5l0.2,0.6l-0.1,0.9l-0.4,0.3l0.7,0.9
	l-0.7,1.3l0.2,0.5l1.1,1l0.5,1.4l0,0l-0.5,0.3l-0.2-0.3h-0.7l-1.8,2l-0.4,0.9l-1,0.6l-1.3,0.1L107.1,281.9z M112.3,284.8l-0.4,0.1
	l0.7-0.7l-0.9,0.2l-0.7,1.3l-0.2-0.6l0.4-0.5l-0.1-0.2l-0.5-0.3l-1.2,0.5l-0.2-0.3l0.4-0.9l3.7-1.4l-0.1,0.5l0.3,0.3l-0.4,2.3
	l-0.4-0.5L112.3,284.8L112.3,284.8z"
        />
        <path
            id="JP-44"
            class="st4"
            d="M44.3,316.5l0.4-0.3l0.5-1.4l-0.8-0.7v-0.6l-0.4-0.2l0.1-0.4l0.5-0.3l0.1-0.6l-0.3-1l-0.3-0.2
	l0.5-0.7l0.5-0.1l0.3-1.6L47,307l0.9-0.2l1,0.3l1.9-0.1l-0.1-0.5l0.4-0.5l-0.3-0.8l0.1-0.4l0,0l0.3-0.4l1.8,0.9l2.6,0.1l0.1-0.5
	l1-0.9l0.5-1l1.7-0.5l1.6,0.8l1.3,1.7l0.3,1.1l-0.1,1.8l-0.3,0.1l-0.4,1.2l-1.4-0.4l-0.2,0.3l0.5,0.6l-0.1,0.2l-0.9,0.1l-0.2,0.6
	l-0.7-0.1l-0.2-0.4l-0.7,0.1l-0.1,0.7l0.4,1.5l1.5,0.5l1.9-0.8l1.3,1l3-0.7l-1.4,2l-0.5,1.3l0.7,0.3l1.1-0.5l0.3,0.3l-0.7,0.3
	l-0.4,0.7l1,0.3h0.3l0.3-0.7l0.6,0.8l0.4-0.2v-0.5l0.3-0.1l0.1,0.8l-0.5,0.4l-1-0.1l-0.8,1.4l0.1,0.3l0.6,0.2l0.3,0.5l0.7-0.3
	l0.4,0.4l1.6,0.1l0.1,0.3l-2.1,0.3l0.2,0.8h0.6l-0.8,0.8l0.7,0.7l-1.4,1l-0.9-0.5L65,325l0,0h-0.6l0.3-1.6l-1.6-0.6l-0.8,0.1
	l-0.1,0.7l-0.5,0.6h-2.2l-0.5,0.4l-0.9-0.3l-0.2-0.3l0.2-0.5l-0.8-0.9l-2,0.7h-0.4l-0.5-0.6l0,0l-1.4-1.3l-0.2-2.3l-0.6-1.6
	l-0.9-0.8l-0.2-1.2l-1-1.1l-1.4-0.3l-1,0.6l-0.1,0.7l0.8,1.2l-0.2,0.9l-0.5,0.6h-0.4l-0.4-0.6h-0.6l-0.6-0.8l-0.9-0.2L44.3,316.5
	L44.3,316.5z"
        />
        <path
            id="JP-41"
            class="st4"
            d="M23.8,311.3l0.7,1l0.2-0.9l-0.2-0.2l0.7-1.4l-1.8-1.3l0.5-0.1l-0.3-0.3l0.3-0.3l0.4,0.1l0.3,0.8
	l0.3-0.2l-0.6-1.2V307h0.5l-0.2-0.9l0.6,0.5h0.3v-0.3h0.7v0.3L27,307l-0.6,0.7l0.6,0.5l1.1,0.2l0.3-0.2l-0.1-0.3l0,0L31,308l0.7-0.3
	l0.9,0.2l0.5-0.2l1.7,1.1l0.8,0.2l0.6,0.7l1-1l0.7-0.3l0.4,0.2v2.3h-0.5l-0.5,0.9l-1.9,1.4l-0.6,1l-0.2,1.2l0,0h-1.3l-0.2-0.5
	l-0.9-0.6L32,315l-1.8,1.4l1.8,3.1v0.4h-0.4l0,0l-2.8-0.7l-1.6-1.6l-1.2-0.8l0.1-0.4l0.5-0.1l0.1-0.4l-0.4-0.9l-1,0.1l-1.4-0.6v-1.3
	L23,312l0.6-1l0,0L23.8,311.3L23.8,311.3z M22.2,302.3h-0.6l-0.4-1.1l-0.4,0.5l-0.2-0.7l0.3-0.5l-0.2-0.4l1.1-1.3l1.4,0.5l-0.3,0.9
	l0.5,0.5l-0.6,0.3l0.8,0.3l-0.2,0.5h-1.1C22.4,301.6,22.2,302.3,22.2,302.3z M22.4,308.9l0.4-1l0.8,1l-0.6-0.1l-0.1,0.4l-0.5,0.2
	l-0.3-0.3L22.4,308.9L22.4,308.9z"
        />
        <path
            id="JP-25"
            class="st6"
            d="M154.1,266.5l0.1,0.9l0.7,0.7l-0.7,2.5v1.4l-0.8,1.1l-0.2,0.9l-2.3,1.1l-1.3-0.7h-1l-0.3-0.4
	l-0.5,0.4l0.1,0.3h0.6l0.1,0.3l-0.8,0.6l0.1,0.5l-1.3,0.5l0,0l-0.1-0.4l0.3-0.3l-0.6-0.6l-0.4,0.1l-0.3-0.4h-0.3l-0.1-0.9l-0.7,0.4
	l-0.7-0.5l0.2-1.1l-0.9-1.5l-0.3-1.2l0.3-0.3l0.3-1.7l-0.4-2.1l0.4-1.4h-0.4l-1.2-1.8l0,0l0.4-0.7l0.4-0.1l0.1-0.5h0.6l0.4,0.4
	l0.6-0.3l1-2.8l0.8,0.8l0.5-0.1l0.5-0.9l1.3-0.1l0.4-1.1l1.1,0.3l0.1-0.8l-0.8-1.8l0.3-0.7l0.7-0.1l1.8,0.9l0,0l0.3,1.1l0.7,0.1
	l-0.1,1.6l0.8,0.3l0.3-0.5l0.6,0.7l-0.2,0.9l0.6,0.6l-0.1,1l0.5,0.9l-0.6,0.4v1.3l-0.3,0.5v0.9l-0.3,0.2L154.1,266.5z"
        />
        <path
            id="JP-32"
            class="st8"
            d="M73.2,270.3l0.3-0.8l1.2-0.9l0.1-0.7l0.5-0.7l2.5-1.8l1.4-0.5l0.6-0.5l0.4-0.8l0.1-1.6l-1-0.4
	l0.1-0.4l1.1-0.5L81,261l0.9-0.2l0.1-0.2l-0.6-0.4l1.4-0.3l0.2-0.3l2.1-0.5h1l-0.1-0.6l1.2,0.1l0.4-1l0.9-0.6l0.9,1.1l1.1-0.2
	l0.4-0.3l2.2,0.3l-1.2,0.3l-0.4,0.5l0.5,1l1.1,0.7l0,0l-0.2,2.4l-0.4,0.6l0.3,1.6l-3.1,1.4v0.3l0.6,0.1l0.2,0.7l-0.9,0.7l-0.2,1.5
	l0,0l-0.6-0.2l-1.4,0.4l-1-0.8l-0.8,0.6l-1.1-0.7l-0.4,0.1l-2.4,3.3l-1.2,0.3l-0.9,1l0.4,0.5l0.7,0.2v0.9l-1.8,0.1l-1.5,1.1
	l-1.6-0.1l-0.3-0.4l-0.4,0.1l0.1,0.3l-0.5,0.4l-0.5-0.4l-1.2,0.1l0,0.5l-0.4-0.5l-0.8-0.1l-0.3,1.1l-1.4,0.9l-0.3,0.5l0.6,0.3
	l-0.7,1l-0.2,1.8l-0.6,0.7l-0.6,0.2l-0.3,0.6l0.5,0.6l0,0l-0.8,0.5l-0.5,0.7l-0.1,0.3l0.4,0.9l-1.1,1.6l-0.7-0.6l-0.9,0.7l-1.1,0.1
	l-0.9-0.9l-0.2-0.8l0.6-1.5h-1.9l-0.6-1.6l0.7-0.6v-0.8l0.4-0.2l-0.8-2.5l0,0h1.1l1.5-0.5l1.3-1.5l1.1-0.8l0.2-0.7l0.6-0.2l1.2-1.2
	l0.8-1.2l2.9-2.4L73.2,270.3L73.2,270.3z M91.3,242.9l-0.4-0.5l-0.5-0.1l0.2-0.8l-0.3-0.2l0.1-0.9l0.9-1l1.1-0.3l0.8,0.3l1.3,1.5
	l-0.3,1.5l-0.4,0.2l-0.1-0.6l-0.1,0.4l-0.6,0.1l0.6,0.1l0.1,0.6l-0.3,0.1l-1.8,0.1l0.1-0.4L91.3,242.9L91.3,242.9z M45.2,209.8
	l0.3-0.2l0.2,0.2l-0.2,0.3l0.1,1l-0.8,0.9l-1.3-0.5l-0.3-1l0.6-0.4L45.2,209.8L45.2,209.8z M88.3,244.1l0.3,0.1l-0.1,0.3l-0.9,0.5
	l0.3,0.5l-0.2,0.6l-0.4-0.1l-0.4-0.7h-0.4l-0.2,0.2l0.4,1.1l-1-0.6l0.6-1.2l0.7-0.1v-0.5l0.7,0.2L88.3,244.1L88.3,244.1z
	M89.4,245.4l-1.3,1.3l0.2-0.8l-0.3-0.8l0.3-0.2l0.3,0.3l0.1-0.5l0.4-0.1l0.4,0.2L89.4,245.4L89.4,245.4z M86.9,246.7l1.4,0.5
	l-0.1,0.4l-1.2-0.2L86.9,246.7L86.9,246.7z"
        />
        <path
            id="JP-11"
            class="st5"
            d="M199.7,249.8l0.2-0.5l-0.5-1.1l0.1-0.5l0,0l0.8-1h1.2l0.9-1l1.5-0.4l0.5-0.8l1.5-0.1l0.4-0.8v-0.9
	l1.2-2l0.7,0.1l1.7,0.9l0.6-0.1l1,0.3l0.9-0.2l1.8,1.3l2.5-0.5l0.5,0.5l0.5-0.2l0.3-0.6l0,0l0.8,0.4l0,0l-0.2,0.9l0.9,2l0.4,0.1
	l0.4-0.4l0,0l0.7,1.4l0.1,1l1.7,3.2l-0.2,1.3l-0.4,0.3l0,0l-0.9,0.1l-0.2-0.4l-0.5,0.1l-0.5-0.3l-0.4,0.7l-1.8-0.3l-0.7,0.8
	l-0.5-0.3l-0.9,0.4l-0.3-0.9l-1.6,0.8h-1.3l-0.5-0.6l-0.8-0.1l-0.4-0.9l-2.1-0.1l-1-0.6l-1.7-0.3l-0.7-0.5l-1.4,0.6l-0.2,0.4l0,0
	l-1.1,0.3l-0.7-0.5l-1.2-0.2l-0.3-0.6L199.7,249.8z"
        />
        <path
            id="JP-22"
            class="st0"
            d="M207.3,274.7l-1.1,2l-1.2,1l-0.5,1.3l0.3,0.8l-0.5,0.2l-0.5-0.3l-0.4,0.2l-0.2,0.5l-1.3,0.7
	l-0.4-0.1l-1.1-1l0.2-0.3l-0.1-0.4l-0.7-0.3v-0.8l0.7-0.7l-0.5-1.1l0.3-0.2l-0.2-1.8l0.7-0.6l-0.5-1.5l0.5-1.2l2,0.2l0.3-0.7
	l-1.8-1.6l-2.3-0.5l-2.7,0.8l-0.9,1.6l0.4,0.5l-0.2,0.6l-3.1,1.7l-0.8,1.3l0.2,1l-0.7,1.2l-1.5,1.1l-0.5,1.4v0.7l0.8,0.7l-0.1,0.2
	l-4.5-1.6l-2.1-0.1l-1.8,0.5l-2.7-0.6l-3.6-0.1l0,0l-0.2-2.3l0.4-1.2l2.8-1.5l1.3-1.9v-1.1l1.5-2l0.5-0.2l-0.1-0.5l0.6-0.6l-0.5-0.5
	l0.3-1l0,0l1.1-0.1l0.5-0.9h0.5l0.2-0.4l1.3-0.6l1.2-1l1.6-0.6l0.1-0.7l-0.5-0.7v-0.7l0.7-0.3l-0.4-1.3l0.4-0.6l-0.3-0.3l0.6-0.6
	l0.4,0.1l0.6-1.6l0,0l0.9,3.2l-0.4,1.2l0.2,1.1l-0.5,0.9l0.3,1.3l0.7,0.5l0.8-0.5l0.8,0.4l0.7,2.7l0.7,0.5l1.2,0.1l0.7-0.6l-0.4-2.7
	l0.4-0.6v-1.7l1-0.9l0.6,1.3l1-0.1l0.5,1l2.8-0.5l0.4-0.3l0.7,0.1l0.7-0.4l0,0h1.5l0.1,0.2l0.4,1.5l-0.3,1l-0.6,0.6l0.2,1.5l0.7,0.5
	l0.1,0.7l1.5,0.2l0,0l-0.7,1l-0.1,1l0.6,0.3l-0.1,1.3l1,0.8l-0.1,1.5L207.3,274.7z"
        />
        <path
            id="JP-09"
            class="st5"
            d="M229.9,224.7l-0.1,2l0.3,1l-0.2,1.3l0.6,1l-0.1,0.3l-1,0.2l-0.3,0.4l0.6,1.9v1.8l-0.9,1.9l-0.2,1.2
	l-0.7,0.2l-0.3-0.4h-0.5l-0.4,0.5l-0.7-0.2v0.5l-0.3,0.1l-1.6,0.1l-0.1,0.4l-1,0.5l-0.1,0.9l-1.1-0.3l-0.6,1.7l-1.6,0.9l-0.7,0.1
	l0,0l-0.8-0.4l0,0l-0.5-0.8l0.1-0.3l-0.4-0.2l-1.1,0.2l-0.7-0.4l-1,0.3l-1.1-1v-0.6l-1-0.8l0.2-1l1.2-1.6l-0.3-0.8l0.4-1.2l0.8-0.6
	l-0.3-0.7l-1.2,0.1l-1.5-0.7l0.2-1.4l0.6-0.9l-0.3-1.2l1-1.4l-1-0.4l0.6-1.5l0,0l0.9-0.4l0.7-1l1.4-0.2l0.9-0.8l0.6-0.1l0.2-0.4
	l0.8-0.2l0.3-0.4l2.8-0.9l0.2-0.9l1.4-0.6l2.4,0.3l2.4,1l1,1l0.2,0.9l0.9-0.1l-0.2,1.9L229.9,224.7z"
        />
        <path
            id="JP-13"
            class="st5"
            d="M212.8,279.1l-0.7-0.4l-0.1-0.4l-0.1-1.4l0.2-0.5l1.2,0.4l0.5,0.9l-0.2,1.5L212.8,279.1L212.8,279.1
	z M210.7,285.3l-0.3,2.3l-0.5-0.4l-0.1-0.5L210.7,285.3L210.7,285.3z M209.2,287.5l0.3,0.3l-0.6,0.2L209.2,287.5z M221.6,256.4
	l-0.8-0.1l-0.2-0.9l-0.5,0.4l-0.3,1.6l0.3,0.8l0.3-0.1l0.4,0.7l-0.9-0.2l-0.9,0.3l0,0v-0.4l-0.5-0.2l-0.3-0.7l-2.7-1.3l-0.8,0.9
	l-0.5-0.5l-0.2,0.2l0.8,0.6l-0.2,2h-0.3l-1.4-1.9l-2.1-0.7l-0.9,0.2l-0.6-1h-0.6l-0.5-0.6l-0.6-0.1l0,0l-2.1-1.2l-1.6-3.2l0,0
	l0.2-0.4l1.4-0.6l0.7,0.5l1.7,0.3l1,0.6l2.1,0.1l0.4,0.9l0.8,0.2l0.5,0.6h1.3l1.6-0.8l0.3,0.9l0.9-0.4l0.5,0.3l0.7-0.8l1.8,0.3
	l0.4-0.8l0.5,0.3l0.5-0.1l0.2,0.4l0.9-0.1l0,0l1.1,2.3l0,0l0.4,0.8l-0.6,0.3l0.4,0.4l-0.8,0.6L221.6,256.4L221.6,256.4z M215.9,294
	l0.3-0.5V293l-0.5-0.5l-0.9,0.1l-0.4,1l0.2,0.6l0.7,0.1L215.9,294z M220.4,317.3l1,0.6l0.1-0.7l0.4-0.1l-0.3-0.9h-0.5l-0.9-0.9h-0.5
	l-0.2,0.7l0.3,0.6l0.4,0.1L220.4,317.3L220.4,317.3z M220.4,317.3l1,0.6l0.1-0.7l0.4-0.1l-0.3-0.9h-0.5l-0.9-0.9h-0.5l-0.2,0.7
	l0.3,0.6l0.4,0.1L220.4,317.3L220.4,317.3z"
        />
        <path
            id="JP-36"
            class="st3"
            d="M120.8,299.6l-2.1,0.9l-0.9,0.8l-0.2,0.5l-1.3,0.9l-1.2,0.7l-0.9,0.2l-0.6,1.8h-0.9l-0.2,0.5
	l0.3,0.1l-0.3,0.2l0,0l-2.1-0.2l-0.8-1.2l-0.1-0.5l0.5-0.5l-0.2-0.8h-2l-0.1-2l-0.5-1.3l-0.7,0.2l-0.3-0.5l-0.4,0.1l-0.4,0.8
	l-0.6,0.2l-0.8-0.3l-0.6-0.9l-1.8,0.2l-1.3-0.5l-0.4-0.5l0,0l0.6-0.9v-1l-0.3-0.5l0.3-0.7l0,0l0.6-0.2l0.1-0.5l1-0.8l0.6,0.2
	l0.3-0.5l0.8-0.3l1.4-0.3l0.9,1h0.5l1.2-0.9l1.2-0.1l0.3-0.3l-0.1-0.4l0.7-0.6l1.7-0.2l1.6,0.3l0.3-0.3l1.1,0.6l0.4-0.2l0.2-1l0,0
	l2.8-0.8v0.9l0.8,0.5l-0.7,3l0.1,1.1l0.5,0.5l0.4-0.6l0.6,1.1l0.6,0.4l-0.5,0.4l0.7,0.2l-0.1,0.5l-1.3,0.9l-0.1,0.3l0.3,0.2h2
	l0.1,0.2L120.8,299.6L120.8,299.6z"
        />
        <path
            id="JP-31"
            class="st8"
            d="M91.4,261.1l1.7,0.3l0.6-0.2l0.6-1l1.2-0.6l2.1-0.4l1.7,0.7l2.1,0.2l4-0.3l0.8-0.4l1.7,0.2l2.2-0.2
	l3.3-0.9l0.7-0.9l0.9-0.1l0.2-0.5l0.7-0.2l0,0l0.8,0.6l0.4,0.9l-0.1,1.2l0.6,2.2l0.9,0.4l-0.1,1.3l0.9,1.1l-0.2,0.5l0.3,1.4
	l-1.9,1.4l-0.7-0.3l0,0l-0.4-0.3l-1.6,1.4l-0.8,0.2l-0.6-0.3l-1.7,1.1l-0.6-0.7l0.2-0.8l-0.6-0.4l0.1-0.7l-0.3-0.5l-0.8-0.7
	l-1.1,0.2l-0.9-0.2l-0.2-0.2l0.2-1l-1.8,0.5v0.6l-1.4,0.6l-0.2,0.6l-0.8,0.6l-0.6-1.1l-1.3-0.9h-1.5l-2-0.7l-0.9,2.9l-1.1,0.3
	l0.2,0.6l-0.2,0.6l-1.4,0.6l-0.9-0.4l-0.3,0.4l0.4,1.4l-2.1,0.7l-0.4-0.3l-0.3,1l-0.4,0.3l0,0l-0.5-0.6l-2.5,0.4v-0.3l0,0l0.2-1.8
	l1-0.8l-0.3-0.8l-0.7-0.2v-0.3l3.7-1.6l-0.3-1.9l0.5-0.7L91.4,261.1L91.4,261.1z"
        />
        <path
            id="JP-16"
            class="st0"
            d="M167.9,228.4l1.3,0.7l1-0.2l1.9,0.1l1.2-1.1l0.4-1v-1.2l0.4-0.7l1.3-0.7l2.8-0.6l0,0l0.7,0.8
	l0.8,0.3v1.2l0.4,0.6v0.8l0.6,1.7l0,0l-0.2,4.2l-1.2,0.7l-0.1,0.8h0.2l0.1,0.5l-0.6,0.2l-0.4,0.5v0.8l-0.4,0.8l-0.9,0.9l0,0
	l-0.9-0.1l-0.8-0.8l-0.7,0.3l-1.1-0.4l-0.3-0.8l-1.4,0.8h-0.2v-0.9l-0.6-0.1l-1.5,0.7l-0.3-0.4h-0.5l-2.1,2l-0.3,1.1l-1.4,1.2
	l-0.3-0.1l0.3-0.7l-0.3-0.8l-0.9-0.5l-0.4,0.4l-0.3-0.6l-0.8,0.6l-0.3,1.1l-0.6,0.1l0,0l-0.1-0.9l0.3-0.4l-0.5-1.9l0.8-2.9l-0.5-0.6
	l-0.2-1.1l0.8-1.2l-0.2-0.5l0.2-1l0.5-0.6l0.6-3.5l1.4-1.4l0.7-0.3l1.2,0.1l0,0l-1.3,2.3l1.4,1.6l0.7,0.5L167.9,228.4z"
        />
        <path
            id="JP-30"
            class="st6"
            d="M142.4,306.9l-0.5,0.4l-0.3,0.7l0.1,0.7l-0.5,0.1l-0.3-0.4l0.3-0.8l-0.8,0.1l-1.9-0.8l-2.4-0.4
	l-2-1.2l-0.4-0.7l0.1-0.8l-1.3-0.6l1-0.5l0.3-0.6l-1.4-1.2l-2.6-1.2l-0.7-1.4l-0.8-0.4l-1.1,0.3l0.2-2.3l1.6-0.6l0.5-0.6l-0.7-0.8
	l-1.1-0.3l0.6-0.6l0.3-0.8l0.9,0.1l0.3-0.4l-0.1-0.8l-0.8-0.2l-0.4-1.2l-1-1.1l0.1-0.5l0.4-0.1l0,0l0.3,0.1l0.1,0.9h0.4l1-0.2
	l1.2-0.8l1.6-0.1l2.1-0.7l1.6,0.1l1.2-0.8l1.3-0.2l0,0l0.4,0.7l0.2,1.7l0.9,0.5l0.2,0.7l-0.4,0.6l-0.8-0.4l-0.6,0.3v0.7l-0.4,0.6
	l-1.5,1.5l-0.1,0.5l1.1,1l-0.1,0.5l0.6,0.2l0.3,0.5l-0.7,1.8l0.4,0.1l0.2,0.6l1.1-0.7h0.7l0.7,0.4l2-0.3l0,0l-0.1,1.9l1.7,1.9
	l1.3,0.3l0,0l-0.3,0.5l-0.1,1.1l-1,0.3l-0.2,0.9l0.7,0.3l-0.1,0.4l-2.1,1.5L142.4,306.9L142.4,306.9z"
        />
        <path
            id="JP-35"
            class="st8"
            d="M57.4,294.9l-0.6-0.4l-0.4,0.9l-0.7,0.4l-0.3-0.2l0.1-0.6l-0.4-0.1l-0.8,1.5l-1.7,1l-2.2-0.8
	l0.1-0.8l-2.3-1.3l-0.7,0.4l-0.3,0.9l-1.8,1.8l-0.2-0.6l0.5-0.9v-1.7l-1.1-1.5l0.1-0.6l0.8-0.1l0.6-1.1l-0.2-1.2l-1.1-1.2l0.3-0.2
	l0.4-1.4l2.6-0.4l-0.3-0.5l-1.2-0.4l0.3-0.8l0.9,0.7l1.1-0.3l0.5,0.1l1.1,1.1l3-0.3l0.6-0.8h1l1.4-1.7l-0.3-0.7l0.4-0.6l0.7,0.1
	l0.7-0.7l0.3-0.4v-0.9l0.5-0.1l0.4-0.9l0.3-0.2l1,0.3l0.5-0.5l0,0l0.8,2.5l-0.4,0.2v0.8l-0.7,0.6l0.6,1.6h1.9l-0.6,1.5l0.2,0.8
	l0.9,0.9l1.1-0.1l0.9-0.7l0.7,0.6l1.1-1.6l-0.4-0.9l0.1-0.3l0.5-0.7l0.8-0.5l0,0l0.3,0.7l-0.2,0.8l0.2,1.4l0.9,0.8l-0.1,0.6l0.5,1.5
	l1.3,0.3l0.3-0.2l0,0l0.2,0.5l-0.3,0.5l0.4,0.5l-1,0.9l0.2,3l-0.6,1l-1.1,0.1v1.6l0.6,0.7l-0.3,0.6l-0.5-1.1l-1.4-0.7l-0.4,0.2
	l-3.6-2.8l-0.5,0.6v0.5l-0.9-0.2l1.1-1.2l-1.3-0.7l-0.5-0.1l-1.8,0.5l-2.1,1L57.4,294.9L57.4,294.9z M72.5,298.5l-0.9-0.1l-0.5,0.5
	l-0.6-0.9l-0.1-0.8l1.2-1l1.4,1.1l1,0.1l1.3-0.9l1.1,0.1l-1.3,1h-0.7l-0.2,0.3l0.2,0.8l-0.9,0.1l-0.1-0.8l-0.4-0.1l-0.5,0.1V298.5
	L72.5,298.5z"
        />
        <path
            id="JP-19"
            class="st0"
            d="M207.6,255.5v2.6l-0.3,0.7l-0.5,0.5l-0.7,0.1l-0.5,0.6l-1.8,0.8l-0.4,1.1l0,0l-0.7,0.4l-0.7-0.1
	l-0.4,0.3l-2.8,0.5l-0.5-1l-1,0.1l-0.6-1.3l-1,0.9v1.7l-0.4,0.6l0.4,2.7l-0.7,0.6l-1.2-0.1l-0.7-0.5l-0.7-2.7l-0.8-0.4l-0.8,0.5
	l-0.7-0.5l-0.3-1.3l0.5-0.9l-0.2-1.1l0.4-1.2l-0.9-3.2l0,0l-0.7-1.8l1-1.1l-0.9-0.9l1-2l0.2-0.1l0.7,0.6l1.8-2.7l1.4,0.6v0.7
	l0.5,0.5l0.5-0.1l0.2-0.4h1.8l0.5,1.1h1l0.7-0.9h0.4l0,0l1,0.2l0.3,0.6l1.2,0.2l0.7,0.5l1.1-0.3l0,0l1.6,3.2L207.6,255.5z"
        />
        <path
            id="JP-06"
            class="st1"
            d="M230.3,199l-0.3,1.7v2l0.5,0.4l-1.3,1.6l-1.3-0.3l-0.7,0.6l-1.5-1.1l-1.2,0.5l-1-1.7l-0.3,0.4
	l-0.6,0.1l-0.6-0.4l-0.9,0.6l-0.6-0.7l-0.8,0.2l0,0l-0.5-0.8l-0.5,0.1l-0.7-0.3l-0.7-1.2l0.6-3.2l0.7-0.5l-0.4-0.8l0.3-0.8l-0.2-1.3
	l0.5-0.8l1.6,0.2l1.4-0.9l0.8-1.6l-1.1-1.2l-1.8-0.5l-0.8-1.1l0.4-2l-0.2-0.3l-1.5-0.3l-1.8-1l0,0l1.2-3.1l1.7-1.5l1.1-1.5l1.1-4.1
	l0.6-1l0.7-2.6l-0.2-0.6l0,0l2.5,0.4l0.4-0.5l1-0.2l0.2,1.2l0.7,0.2l0.8,0.7l3.1,0.9l1.1-0.3l0.4,0.8l1.1,0.1l0.6,1.8l1.5,0.5
	l0.2,0.4l0,0l-0.2,0.4l1.1,1l0.2,1.1l0.8,0.4l-0.7,1.1l0.2,1l-0.4,1.1l-0.4,0.1l-0.7-0.4l-0.1,0.2l0.6,1.4v0.5l-0.4,0.6l0.3,0.9
	l0.6,0.4l0.2,0.7l-0.6,1.6l-1.1,1.1l0.2,0.6l-1,1.3l-0.2,1l0.2,1.2l-1.1,1.6l-0.2,1l-1,0.6h-1.7L230.3,199L230.3,199z"
        />
        <path
            id="line"
            class="st10"
            d="M207.4,387.1c2.5-10.7,12.1-46.5,46.4-73.6c38-30,79.8-28.5,89.9-27.8"
        />
    </svg>
</template>

<script>
export default {
    props: {
        sm: {
            type: Boolean,
            require: true,
        },
    },
    methods: {
        handleClick(e) {
            const res = this.isValidPath(e);

            // Open on click only on desktop
            res &&
                !this.sm &&
                this.$store.state.prefectures[res].main[0] &&
                this.$emit("open", res);
        },
        handleHover(e) {
            const res = this.isValidPath(e);
            res && this.$emit("hover", res);
        },
        handleHoverLeave() {
            this.$emit("hoverleave");
        },
        isValidPath(e) {
            const path = e.target;

            return "id" in path && path.id.startsWith("JP") && path.id;
        },
    },
};
</script>

<style>
.st0 {
    fill: #52af8c;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st1 {
    fill: #4a9ddb;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st2 {
    fill: #4bb2ba;
}
.st3 {
    fill: #f2ed72;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st4 {
    fill: #e08a66;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st5 {
    fill: #4bb2ba;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st6 {
    fill: #8fc05b;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st7 {
    fill: #4d66ac;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st8 {
    fill: #ecb15c;
    stroke: #ffffff;
    stroke-miterlimit: 10;
}
.st9 {
    fill: #a070ac;
}
.st10 {
    fill: none;
    stroke: #000000;
    stroke-width: 0.25;
    stroke-miterlimit: 10;
}
svg {
    pointer-events: none;
}

path[id^="JP"] {
    pointer-events: all;
    /* transition: 0.1s; */
    cursor: pointer;
}

path[id^="JP"]:hover {
    /* drop-shadow(0 0 4px white) */
    filter: brightness(120%);
}

svg:hover > path[id^="JP"]:not(:hover) {
    filter: brightness(90%);
}

.map {
    width: 700px;

    animation: forwards 1.4s fade;
}

@keyframes fade {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
    }
}

@media screen and (max-width: 1300px) {
    .map {
        width: 500px;
    }
}
</style>
